/* eslint-disable complexity */
/* eslint-disable no-console */
/**
 * 聊天会话状态管理
 * @author sunzhiguang
 * @date 2020/6/18
 */
import ImService from "@/server/ImService";
import ChatState, { ICustomAppData, LLMMessageStatus } from "@/types/chat/State";
import { MessageCategoryType, MessageNotifyType, SessionSettingsType } from "@/types/chat/enum";
import {
  ChatMessage,
  ChatMessageType,
  Employee,
  MessageReqType,
  MessageStatus,
  Session,
  SessionType,
  UID
} from "@/types/chat";
import { executePut } from "@/server/dvaHelper";
import Bus from "@/utils/bus";
import findLastIndex from "lodash/findLastIndex";
import remove from "lodash/remove";
import lodashPick from "lodash/pick";
import lodashGroupBy from "lodash/groupBy";
import {
  employeeToUid,
  getSessionIndex,
  isEqualEmployee,
  isEqualUid,
  isInValidSessionInfo,
  messageCompare,
  sendGroupSessionNotify,
  setMessageGroupId,
  sleep,
  addOneSession,
  toMe,
  isNoticeMessage,
  isSysMessage,
  computeAITimestamp,
  getLatestMessages,
  uniqMergedMessage,
  processMessageStatus,
  mapRosters,
  isUnreadSummarySysMesssage,
  isAINoticeChildSessionMessage,
  convertEmployeeToString,
  computeAIUnReadInfo
} from "@/utils/chat//message";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import MessageReadScene from "@jd/jdee.im.sdk/lib/es/enum/MessageReadScene";
import agentReqIcon from "../assets/images/im/icon-ai-doctor.png";
import config, { ChatConfig, getNetCheckUrl } from "@/config/config";
import log from "@/utils/logger";
import { sessionAttrs, sessionSetting, sortSessions } from "@/server/im/SessionService";
import {
  dealSessionNewMessage,
  dealSessionBatchMessage,
  dealMessageMerged
} from "@/server/im/MessageService";
import {
  getAIChatSessionId,
  isAIChatSessionId,
  isAINoticeChildSession,
  isAINoticeSession,
  isAINoticeSessionKey,
  isUnnecessarySession,
  isCustomAppSession,
  isCustomAppSessionPin
} from "@/utils/chat/session";
import { message as AntMessage, message } from "antd";
import {
  cloneDeep,
  difference,
  differenceWith,
  flattenDeep,
  omit,
  uniqBy,
  uniqWith,
  values
} from "lodash";
import CHAT_NOTICE, { NOTICE_APP, TYPE_KEY_SHARE_GREET_MULTI } from "@/contant/chat";
import { getGroupInfo, groupGetBotList, getRobotChangeUserDetailList } from "@/api/egroup";
import { getRobotDetails } from "@/api/appStore";
import {
  addBatchViewCardRead,
  getChatPermission,
  getLiveChatPermission,
  getMessageTagPageList,
  queryAllCustomAppConfig
} from "@/api/chat";
import { FocusSDK, isHomePageUrl, isLinuxOs, isFocusEnv } from "@/utils";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import {
  getFeedbackTags,
  getAllLLMSetting,
  getAgentList,
  messagePush,
  messageStop
} from "@/api/llm";
import { getChatMeetingCode, getLiveChatMeetingCode, isMeetingSessionId } from "@/utils/chat";
import { UserState } from "./user";
import AsyncTaskQueue from "@/utils/asyncTaskQueue";
import { isGroupCleanMessage, isLiveMeetingSessionId } from "@jd/jdee.im.sdk/lib/es/utils/utils";

const logger = log.getLogger("modal:chat");

function defaultSelectedCategory(): MessageCategoryType {
  const types: MessageCategoryType[] = [];
  if (config[ChatConfig.CHAT_SESSION_LIST_GROUP_ALL_ENABLE]) {
    types.push(MessageCategoryType.ALL);
  }
  if (config[ChatConfig.CHAT_SESSION_LIST_GROUP_TIME_ENABLE]) {
    types.push(MessageCategoryType.TIME);
  }
  if (config[ChatConfig.CHAT_SESSION_LIST_GROUP_TYPE_ENABLE]) {
    types.push(MessageCategoryType.TYPE);
  }
  return types[0] || MessageCategoryType.ALL;
}
let isSessionLoad = false;

const defaultState = {
  topCount: 0,
  unReadCount: 0,
  atCount: 0,

  connectState: { state: ConnectState.CONNECTING },
  // 消息提醒类型：全部消息 未读消息 重要消息
  selectedNotifyType: MessageNotifyType.ALL, // 当前选中消息提醒类型
  notifyType: {
    [MessageNotifyType.ALL]: {
      count: 0,
      enable: true,
      // normalIcon: 'iconic_all_normal',
      // selectedIcon: 'iconic_all_hover',
      clstag: "pageclick|keycount|Xtbg_Msg_Home|All",
      title: "remind.all_message" // '全部消息',
    },
    [MessageNotifyType.GROUPS]: {
      count: 8,
      enable:
        config[ChatConfig.CHAT_SESSION_LIST_GROUP_ENABLE] &&
        config[ChatConfig.CHAT_SESSION_LIST_GROUP_UNREAD_ENABLE],
      // normalIcon: 'iconapp_btn_peoplegroup',
      clstag: "pageclick|keycount|Xtbg_Msg_Home|Group",
      // selectedIcon: 'iconapp_btn_peoplegroup',
      title: "remind.all_group" // '组'
    },
    [MessageNotifyType.UNREAD]: {
      count: 89,
      enable:
        config[ChatConfig.CHAT_SESSION_LIST_GROUP_ENABLE] &&
        config[ChatConfig.CHAT_SESSION_LIST_GROUP_UNREAD_ENABLE],
      // normalIcon: 'iconic_unreadl_normal',
      clstag: "pageclick|keycount|Xtbg_Msg_Home|Unread",
      // selectedIcon: 'iconic_unreadl_hover',
      title: "remind.unread_message" // '未读消息'
    },
    [MessageNotifyType.IMPORTANT]: {
      count: 8,
      enable:
        config[ChatConfig.CHAT_SESSION_LIST_GROUP_ENABLE] &&
        config[ChatConfig.CHAT_SESSION_LIST_GROUP_IMPORTANT_ENABLE],
      // normalIcon: 'iconic_important_normal',
      clstag: "pageclick|keycount|Xtbg_Msg_Home|AtMe",
      // selectedIcon: 'iconic_important_hover',
      title: "remind.important_message" // '重要消息'
    }
    // [MessageNotifyType.REMIND]: {
    //   count: 8,
    //   enable: true,
    //   // normalIcon: 'iconic_important_normal',
    //   // clstag: 'pageclick|keycount|Xtbg_Msg_Home|AtMe',
    //   // selectedIcon: 'iconic_important_hover',
    //   title: "remind.remind_message" // '提醒'
    // }
  }, // 消息提醒配置
  // 消息分类： 时间分类，类型分类
  selectedCategory: defaultSelectedCategory(), // 当前选中消息分类 默认时间类型
  category: {
    [MessageCategoryType.ALL]: {
      enable:
        config[ChatConfig.CHAT_SESSION_LIST_GROUP_ENABLE] &&
        config[ChatConfig.CHAT_SESSION_LIST_GROUP_ALL_ENABLE],
      normalIcon: "iconic_all_normal",
      clstag: "pageclick|keycount|focus_chat_01_1615797500283|6",
      selectedIcon: "iconic_all_hover",
      title: "remind.all_message" // '全部消息',
    }
    // [MessageCategoryType.TIME]: {
    //     enable:
    //         config[ChatConfig.CHAT_SESSION_LIST_GROUP_ENABLE] &&
    //         config[ChatConfig.CHAT_SESSION_LIST_GROUP_TIME_ENABLE],
    //     normalIcon: 'iconic_time_',
    //     clstag: 'pageclick|keycount|focus_chat_01_1615797500283|7',
    //     selectedIcon: 'iconic_time_honer',
    //     title: 'category.time_message', // '时间',
    // },
    // [MessageCategoryType.TYPE]: {
    //     enable:
    //         config[ChatConfig.CHAT_SESSION_LIST_GROUP_ENABLE] &&
    //         config[ChatConfig.CHAT_SESSION_LIST_GROUP_TYPE_ENABLE],
    //     normalIcon: 'iconic_type_normal',
    //     selectedIcon: 'iconic_type_honer',
    //     title: 'category.type_message', // '类型'
    // },
  },

  currentEmployee: {},

  // 当前会话成员
  sessionMembers: [],
  // 群成员
  groupRosters: [],

  // 群机器人
  groupRobots: [],

  // 群主信息
  administrator: [],
  // 群管理员信息
  sub_administrator: [],
  // 群普通成员信息
  ordinary: [],
  groupMemberSessionId: "",
  // 消息分类配置
  selectedSession: {},
  preSelectedSessionId: "",

  // 消息上传文件的状态
  messageUploadStateMap: {},

  // 会活消息状态 key 为 sessionId
  sessionStatusMap: {},

  // 输入焦点状态
  messageInputFocus: false,

  // 当前会话监听到的最新消息数据 key 为 sessionId
  sessionMessageMap: {},
  prevAISessionMessages: [],
  // 存放所有临时会话消息 key 为 sessionId
  tempSessionMessageMap: {},
  // 所有会话列表
  allSessionList: [],
  sessionPage: 0,
  sessionLoadEnd: false,
  // AI助手通知消息聚合列表
  aiNoticeSessionList: [],
  selectedAITab: {
    pin: "all-notice"
  },
  loadAllSessionListEnd: false,
  globalDrawerVisible: false,
  messageDrawerVisible: false,
  appcationApplyMessageId: "",
  selectMore: false,
  messages: [],
  type: null,
  imageMessages: [],
  mainWinShow: true,
  identityInfoModal: false, // 北京通号身份信息验证
  filterTabList: [], // AI助手内容tab筛选列表
  sessionScrollIndex: -1, // 会话跳转位置
  sessionUnReadList: [], // 会话未读数
  isDragging: false,
  captureType: "1", // 截屏类型 1：隐藏当前窗口截屏； 2：不隐藏当前窗口
  sendMsgType: "1", // 发送消息快捷键
  // 消息定位
  sMid: -1,
  sText: "",
  sTimestamp: 0,
  skipAnchorId: {},
  NoticeDetailsVisible: false, // 组通知详情
  NoticeHisVisible: false,
  NoticeDetailsHisId: "",
  notificationId: "", // 组通知ID
  solitaireId: "", // 组接龙
  SolitaireDetailsVisible: false,
  solitaireSessionId: "", // 组接龙历史
  SolitaireHisVisible: false,
  updateSessionMessagesTimestamp: 0,
  isMessageModule: false,
  dbVersion: "",
  migrateVisiable: false,
  quickReplyVersion: 0,
  quickReplys: [],
  downloadingMids: [], // 正在下载的mid队列，用于更新下载组件
  saveAsCount: 0, // 另存为次数
  voiceMessageMap: [],
  slitaireMap: {},
  questionHistory: [],
  privateUser: { userName: "所有人", pin: "all" },
  isSelectedColor: "#232930",
  showTagList: [],
  lastUnreadMessage: {},
  showSyncMsgTip: false,
  customAppList: [], // 自定义独立消息会话列表
  noticeInited: false,
  otherTeamNotifyList: {},
  llmTagsList: {}, // 反馈标签列表
  llmSetting: {}, // llm配置
  llmAgentList: [], // llm智能体
  // llm信息存储
  llmInfo: null,
  // llm回答问题状态
  llmQuestionInfo: {},

  topUpExpanded: false, // 置顶会话展开状态

  // 当前选择智能体
  currentAIRobot: {}
};
const taskQueue = new AsyncTaskQueue();
export default {
  namespace: "chat",
  state: { ...cloneDeep(defaultState) },
  reducers: {
    setSelectColor(state: ChatState, { payload }: any) {
      return { ...state, isSelectedColor: payload };
    }, // 聊天字体颜色值
    setPrivateUser(state: ChatState, { payload }: any) {
      return { ...state, privateUser: payload };
    }, // 私聊人员信息
    setShowTagList(state: ChatState, { payload }: any) {
      return { ...state, showTagList: payload };
    },
    setshowSyncMsgTip(state: ChatState, { payload }: any) {
      return { ...state, showSyncMsgTip: payload };
    },
    setVoiceMessageMap(state: ChatState, { payload }: any) {
      return { ...state, voiceMessageMap: payload };
    },
    setIsMessageModule(state: ChatState, { payload }: any) {
      return { ...state, isMessageModule: payload };
    },
    setQuickReplyInfo(state: ChatState, { payload }: any) {
      return {
        ...state,
        quickReplyVersion: payload.quickReplyVersion || 0,
        quickReplys: payload.quickReplys || []
      };
    },
    setIdentityInfoModal(state: ChatState, { payload }: any) {
      return { ...state, identityInfoModal: payload };
    },
    updateMessages(state: ChatState, { payload }: any) {
      const { messages } = payload;
      return {
        ...state,
        messages: [...messages]
      };
    },
    changeSelectMore(state: ChatState, { payload }: any) {
      const { selectMore, type } = payload;
      return {
        ...state,
        selectMore,
        type
      };
    },
    clearData(state: ChatState, { payload }: any) {
      isSessionLoad = false;
      return { ...defaultState, allSessionList: [], llmTagsList: {} };
    },
    setTopCount(state: ChatState, { payload }: any) {
      const { topCount } = payload;
      return {
        ...state,
        topCount
      };
    },
    setUnReadCount(state: ChatState, { payload }: any) {
      const { unReadCount } = payload;
      return {
        ...state,
        unReadCount
      };
    },
    setAtCount(state: ChatState, { payload }: any) {
      const { atCount } = payload;
      return {
        ...state,
        atCount
      };
    },

    updateCount(state: ChatState, { payload }: any) {
      const {
        allSessionList = [],
        currentEmployee,
        selectedSession,
        aiNoticeSessionList = []
      } = state;
      let topCount = 0;
      let atCount = 0;
      allSessionList.forEach((s: Session) => {
        if (((s.settings || {}).top || 0) > 0) {
          topCount++;
        }
        if (s.sessionId === selectedSession?.sessionId) {
          return false;
        }
        const messages = Object.values(s.mentions || {});
        if (messages.length === 0) {
          return false;
        }
        for (let message of messages) {
          const index = message.users.findIndex((user) => {
            return isEqualEmployee(user as Employee, currentEmployee) || user.userId === "all";
          });
          if (index > -1) atCount++;
        }
      });
      let nomalSession: Session[] = [];

      const topUpModeCustom =
        (isFocusEnv()
          ? JSON.parse(FocusSDK.getConfigData())?.topUpModeCustom
          : localStorage.getItem("topUpModeCustom")) || "horizon";

      if (topUpModeCustom === "vertical") {
        nomalSession = allSessionList.filter(
          (item: Session) =>
            aiNoticeSessionList.findIndex((s) => s.sessionId === item.sessionId) === -1
        );
      } else {
        nomalSession = allSessionList
          .filter((item: Session) => item.del === 0)
          .sort((a, b) => {
            return b.timestamp - a.timestamp;
          });
      }
      const sessionUnReadList = nomalSession
        .filter((item: Session) => item.unreadCount > 0)
        .map((item) => {
          return {
            id: item.sessionId,
            index: nomalSession.findIndex((i) => i.sessionId === item.sessionId)
          };
        });
      if (topUpModeCustom === "vertical") {
        const noticeCount = aiNoticeSessionList.reduce((total, s) => {
          let num = total;
          num += s.unreadCount;
          return num;
        }, 0);
        if (noticeCount > 0) {
          const idx = allSessionList.findIndex((s) => isAINoticeSession(s));
          if (idx > -1) {
            sessionUnReadList.unshift({
              id: allSessionList[idx].sessionId,
              index: 0
            });
          }
        }
      }
      console.log("sessionUnReadList===", sessionUnReadList);

      // 发送数量变更通知
      return { ...state, atCount, topCount, sessionUnReadList };
    },

    updateNotifyType(state: ChatState, { payload }: any) {
      const { selectedNotifyType } = payload;
      return {
        ...state,
        notifyTypeTitle: state.notifyType[selectedNotifyType].title,
        selectedNotifyType
      };
    },
    updateCategory(state: ChatState, { payload }: any) {
      const { selectedCategory } = payload;
      return {
        ...state,
        categoryTitle: state.category[selectedCategory].title,
        selectedCategory
      };
    },
    // 更新当前会话session 并初始化
    initSelectedSession(state: ChatState, { payload }: any) {
      console.log("initSelectedSession-payload:", payload);
      const { selectedSession } = payload;
      const {
        allSessionList,
        sessionMessageMap,
        tempSessionMessageMap,
        selectedSession: currSession,
        sMid
      } = state;
      const preSessionId = currSession?.sessionId || "";
      // tj: 消息数据缓存
      if (selectedSession.sessionId && !sessionMessageMap[selectedSession.sessionId]) {
        sessionMessageMap[selectedSession.sessionId] = [];
      }
      // 把不是当前会话的数据置空
      if (selectedSession.sessionId !== currSession?.sessionId) {
        for (let key of Object.keys(sessionMessageMap)) {
          if ((key === selectedSession.sessionId && sMid !== -1) || isAINoticeSessionKey(key)) {
            sessionMessageMap[key] = [];
            continue;
          }
          const index = getSessionIndex(allSessionList, { sessionId: key });
          if (index < 0) {
            continue;
          }
          const msgs = [...sessionMessageMap[key]];
          const msgLen = msgs.length;
          if (key === currSession?.sessionId) {
            if (sMid !== -1) {
              sessionMessageMap[key] = [];
            }
          }
          // console.log('tempSessionMessageMap=>', tempSessionMessageMap);
          tempSessionMessageMap[key] =
            tempSessionMessageMap[key]?.filter(
              (item: any) => !!item.taskId || item.status === MessageStatus.FAILED
            ) || [];
          if (msgLen) {
            const msg = sessionMessageMap[key]
              .slice(-8)
              .filter((m: any) => m.statusType !== MessageStatus.TEMP);
            sessionMessageMap[key] = msg;
          }
        }
      }

      return {
        ...state,
        mainWinShow: true,
        selectedSession: selectedSession,
        preSelectedSessionId: preSessionId,
        sessionMessageMap,
        tempSessionMessageMap,
        questionHistory: []
      };
    },

    initSelectedAITab(state: ChatState, { payload }: any) {
      const { selectedAITab } = payload;
      // 初始化 sessionMessageMap
      const { sessionMessageMap, selectedSession } = state;
      if (selectedAITab.pin === CHAT_NOTICE.ALL_PIN) {
        sessionMessageMap[selectedSession.sessionId] = (
          sessionMessageMap[selectedSession.sessionId] || []
        ).slice(-5);
      }
      return {
        ...state,
        mainWinShow: true,
        selectedAITab,
        sessionMessageMap
      };
    },

    updateSessionMembers(state: ChatState, { payload }: any) {
      const { sessionMembers } = payload;
      return {
        ...state,
        sessionMembers: sessionMembers || []
      };
    },

    updateGroupRosters(state: ChatState, { payload }: any) {
      const { administrator, sub_administrator, ordinary, groupMemberSessionId } = payload;
      return {
        ...state,
        administrator: administrator || [],
        sub_administrator: sub_administrator || [],
        ordinary: ordinary || [],
        groupMemberSessionId
      };
    },

    setGroupRobots(state: ChatState, { payload }: any) {
      const { groupRobots } = payload;
      return {
        ...state,
        groupRobots
      };
    },

    removeGroupMember(state: ChatState, { payload }: any) {
      const groupRosters = state.groupRosters;
      const member: UID = payload.member;
      remove(groupRosters, (item) => item.info?.userId === member?.pin);
      return {
        ...state,
        groupRosters: [...groupRosters]
      };
    },

    changeGroupAdmin(state: ChatState, { payload }: any) {
      const { administrator, ordinary } = payload;
      return {
        ...state,
        administrator: administrator || [],
        ordinary: ordinary || []
      };
    },

    updateGroupMembers(state: ChatState, { payload }: any) {
      const { groupRosters } = payload;
      return {
        ...state,
        groupRosters: groupRosters
      };
    },

    updateSelectedSession(state: ChatState, { payload }: any) {
      const { selectedSession } = payload;
      console.log("updateSelectedSession:", payload);
      return {
        ...state,
        selectedSession: { ...selectedSession }
      };
    },

    updateSessionData(state: ChatState, { payload }: any) {
      const { session } = payload;
      const { allSessionList } = state;
      const index = getSessionIndex(allSessionList, { sessionId: session.sessionId });
      const newState: any = {};
      if (index >= 0) {
        allSessionList[index] = session;
        newState.allSessionList = [...allSessionList]; // 暂时先更新列表，因为置顶需要同步改变
      }
      return {
        ...state,
        ...newState
      };
    },

    updateSelectedAITab(state: ChatState, { payload }: any) {
      const { selectedAITab } = payload;
      return {
        ...state,
        selectedAITab: { ...selectedAITab }
      };
    },

    setCurrentEmployee(state: ChatState, { payload }: any) {
      return { ...state, currentEmployee: payload.currentEmployee };
    },
    updateCurrentEmployee(state: ChatState, { payload }: any) {
      return {
        ...state,
        currentEmployee: { ...state.currentEmployee, ...payload }
      };
    },
    setStartMessageId(state: ChatState, { payload }: any) {
      const { sMid = undefined, sText = undefined, sTimestamp, skipAnchorId = undefined } = payload;
      const newState = {
        ...state,
        sTimestamp
      };
      if (sMid !== undefined) {
        newState.sMid = sMid;
      }
      if (sText !== undefined) {
        newState.sText = sText;
      }
      if (skipAnchorId !== undefined) {
        newState.skipAnchorId = { ...skipAnchorId };
      }
      return {
        ...newState
      };
    },
    clearSessionAllMessage(state: ChatState, { payload }: any) {
      const newState = state;
      const {
        allSessionList = [],
        sessionMessageMap = {},
        tempSessionMessageMap = {},
        sessionStatusMap = {}
      } = newState;
      const { sessionId } = payload;
      // TODO 去掉 allSessionList中的lastMsg wzp 2021-03-19
      // start
      try {
        for (let item of allSessionList) {
          if (item.sessionId === sessionId) {
            item.lastMsg = undefined;
          }
        }
      } catch (e) {
        console.warn(e);
      }

      sessionMessageMap[sessionId] = [];
      tempSessionMessageMap[sessionId] = [];
      delete tempSessionMessageMap[sessionId];
      delete sessionStatusMap[sessionId];

      newState.tempSessionMessageMap = tempSessionMessageMap;
      newState.sessionMessageMap = sessionMessageMap;
      newState.sessionStatusMap = sessionStatusMap;
      // console.log(newState, 'newStatenewStatenewState');
      return {
        ...newState
      };
    },
    clearMessageBySession(state: ChatState, { payload }: any) {
      const newState = state;
      const { sessionMessageMap = {} } = newState;
      const { sessionId } = payload;
      sessionMessageMap[sessionId] = [];
      return {
        ...newState,
        sessionMessageMap: { ...sessionMessageMap }
      };
    },
    clearAISessionAllMessage(state: ChatState, { payload }: any) {
      const newState = state;
      const { sessionId } = payload;
      const { aiNoticeSessionList = [], selectedSession } = newState;
      // 初始化 sessionMessageMap
      const sessionMessageMap = newState.sessionMessageMap || {};
      aiNoticeSessionList.forEach((item: any) => {
        item.lastMsg = undefined;
        sessionMessageMap[item.sessionId] = [];
      });
      const selectedSessionId = selectedSession?.sessionId;
      sessionMessageMap[selectedSessionId] = [];
      if (sessionId) {
        sessionMessageMap[sessionId] = [];
      }
      return {
        ...newState,
        sessionMessageMap
      };
    },
    clearSessionStatusMap(state: ChatState) {
      const newState = state;
      newState.sessionStatusMap = {};
      newState.tempSessionMessageMap = {};
      newState.sessionMessageMap = {};
      return {
        ...newState
      };
    },
    updateSessionMessage(state: ChatState, { payload }: any) {
      const newState = state;
      newState.sessionMessageMap = { ...payload.sessionMessageMap };
      return { ...newState };
    },

    updateSessionMessagesTimestamp(state: ChatState, { payload }: any) {
      const newState = state;
      newState.updateSessionMessagesTimestamp = payload.timestamp;
      return { ...newState };
    },

    deleteSessionMessage(state: ChatState, { payload }: any) {
      const { sessionMessageMap, tempSessionMessageMap } = state;
      const message = payload.message as ChatMessage;
      const sessionMessage = sessionMessageMap[message.sessionId];
      const tempMessage = tempSessionMessageMap[message.sessionId] || [];
      remove(sessionMessage, (item) => {
        return item.id === message.id;
      });
      remove(tempMessage, (item) => {
        return item.id === message.id;
      });
      sessionMessageMap[message.sessionId] = [...sessionMessage];
      tempSessionMessageMap[message.sessionId] = [...tempMessage];
      return {
        ...state,
        sessionMessageMap,
        tempSessionMessageMap
      };
    },
    deleteSessionMessages(state: ChatState, { payload }: any) {
      const { sessionMessageMap, tempSessionMessageMap } = state;
      const { forwardIdList = [], sessionId } = payload;

      const sessionMessage = sessionMessageMap[sessionId];
      const tempMessage = tempSessionMessageMap[sessionId] || [];
      forwardIdList.forEach((forwardData: { id: string; mid: number }) => {
        remove(sessionMessage, (item) => {
          return item.id === forwardData.id;
        });
        remove(tempMessage, (item) => {
          return item.id === forwardData.id;
        });
      });

      sessionMessageMap[sessionId] = [...sessionMessage];
      tempSessionMessageMap[sessionId] = [...tempMessage];
      return {
        ...state,
        sessionMessageMap,
        tempSessionMessageMap
      };
    },

    pushChatMessage(state: ChatState, { payload }: any) {
      const { message, sessionId, duplicate = false } = payload;
      if (sessionId && message) {
        const {
          sessionMessageMap = {},
          tempSessionMessageMap = {},
          messageUploadStateMap = {}
        } = state;
        const sessionMessage = sessionMessageMap[sessionId] || [];
        const prev = sessionMessage[sessionMessage.length - 1];

        message.beforeMid = prev?.mid || prev?.beforeMid || -1;
        // tj: 增加消息排序
        setMessageGroupId(message, prev || null);
        // 处理最后一条状态
        const last = sessionMessage.length - 1;
        if (sessionMessage[last]?.flag === "loading") {
          sessionMessage[last].flag = "end";
        }
        // ai 提示语更新
        if (message?.type === TYPE_KEY_SHARE_GREET_MULTI) {
          const idx = sessionMessage.findIndex((i) => i.id === message.id);
          if (idx > -1) {
            sessionMessage.splice(idx, 1);
          }
        }
        sessionMessageMap[sessionId] = [...sessionMessage, message].sort(messageCompare);
        if (duplicate) {
          sessionMessageMap[sessionId] = uniqBy(sessionMessageMap[sessionId], "id");
        }
        // 临时消息，发送的消息体暂时存放在这里
        const tempSessionMessage = tempSessionMessageMap[sessionId] || [];
        tempSessionMessage.push(message);
        tempSessionMessageMap[sessionId] = tempSessionMessage.sort(messageCompare);
        const newState = {
          ...state,
          sessionMessageMap,
          tempSessionMessageMap
        };
        if (message.task) {
          FocusSDK.sendTrackLog({
            type: "UPDFILE",
            data: {
              id: message.task?.id,
              nid: message.id
            }
          });
          // 文件消息需要将消息放入上传状态进管理
          messageUploadStateMap[message.id] = {
            message: message,
            task: message.task,
            progress: 0,
            uploadResult: {}
          };
          Object.assign(newState, { tempSessionMessageMap });
        }
        return newState;
      }
      return state;
    },

    pushChatMessageMid(state: ChatState, { payload }: any) {
      const { message, sessionId } = payload;
      if (sessionId && message) {
        const {
          sessionMessageMap = {},
          tempSessionMessageMap = {},
          messageUploadStateMap = {}
        } = state;
        const sessionMessage = sessionMessageMap[sessionId] || [];
        const prev = sessionMessage[sessionMessage.length - 1];

        message.beforeMid =
          message.beforeMid > 0 ? message.beforeMid : prev?.mid || prev?.beforeMid || -1;
        // tj: 增加消息排序
        setMessageGroupId(message, prev || null);
        sessionMessageMap[sessionId] = [...sessionMessage, message].sort(messageCompare);

        const tempSessionMessage = tempSessionMessageMap[sessionId] || [];
        if (message.mid === 0) {
          // 临时消息，发送的消息体暂时存放在这里
          tempSessionMessage.push(message);
          tempSessionMessageMap[sessionId] = tempSessionMessage.sort(messageCompare);
        }
        const newState = {
          ...state,
          sessionMessageMap,
          tempSessionMessageMap
        };
        if (message.task) {
          FocusSDK.sendTrackLog({
            type: "UPDFILE",
            data: {
              id: message.task?.id,
              nid: message.id
            }
          });
          // 文件消息需要将消息放入上传状态进管理
          messageUploadStateMap[message.id] = {
            message: message,
            task: message.task,
            progress: 0,
            uploadResult: {}
          };
          Object.assign(newState, { tempSessionMessageMap });
        }
        return newState;
      }
      return state;
    },

    // 设置消息会话状态数据
    setSessionStatus(state: ChatState, { payload }: any) {
      const sessionId = payload.sessionId;
      const newSessionStatusInfo = payload.sessionStatusInfo;
      const sessionStatusMap = state.sessionStatusMap || {};
      const oldSessionStatusInfo = sessionStatusMap[sessionId] || {};
      if (newSessionStatusInfo.info.content) {
        sessionStatusMap[sessionId] = { ...oldSessionStatusInfo, ...newSessionStatusInfo };
      } else {
        delete sessionStatusMap[sessionId];
      }
      return {
        ...state,
        sessionStatusMap: { ...sessionStatusMap }
      };
    },

    setTopUpExpanded(state: ChatState, { payload }: any) {
      return {
        ...state,
        topUpExpanded: payload
      };
    },

    // 消息焦点状态
    setMessageInputFocus(state: ChatState, { payload }: any) {
      return {
        ...state,
        messageInputFocus: payload
      };
    },

    reSortAllSessionList(state: ChatState, { payload }: any) {
      const allSessionList: Session[] = payload.allSessionList;
      // console.log('排序前', allSessionList);
      const list = sortSessions(allSessionList);
      // console.log('排序后', list);
      // const list = allSessionList.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
      const aiSessionIndex = list.findIndex((item: Session) => isAINoticeSession(item));
      if (aiSessionIndex > -1 && (list[aiSessionIndex].settings.top || 0) > 0) {
        const [aiSessionItem] = list.splice(
          list.findIndex((item: Session) => isAINoticeSession(item)),
          1
        );
        list.splice(0, 0, aiSessionItem);
      }
      return {
        ...state,
        allSessionList: [...list]
      };
    },

    // 通知消息会话列表
    updateSessionList(state: ChatState, { payload }: any) {
      const allSessionList: Session[] = payload.allSessionList;
      const oldSessionList = state.allSessionList;
      for (const s of allSessionList) {
        const idx = oldSessionList.findIndex((i) => i.sessionId === s.sessionId);
        if (idx > -1) {
          oldSessionList[idx] = s;
        } else {
          oldSessionList.push(s);
        }
      }
      const list = sortSessions(oldSessionList).filter((s) => !isUnnecessarySession(s));
      const aiSessionIndex = list.findIndex((item: Session) => isAINoticeSession(item));
      if (aiSessionIndex > -1 && (list[aiSessionIndex].settings.top || 0) > 0) {
        const [aiSessionItem] = list.splice(
          list.findIndex((item: Session) => isAINoticeSession(item)),
          1
        );
        list.splice(0, 0, aiSessionItem);
      }
      const aiNoticeSessionList = oldSessionList.filter(
        (session: Session) =>
          session.isNotice && isAINoticeChildSession(session, state.customAppList)
      );
      // console.log('排序后111', list);
      // 更新 sessionStorage
      if(allSessionList.length > 0){
        const miniSessionInfo = allSessionList.filter(s => s.sessionType === 2).map((e: any) => {
          return {
            isGroup: e.isGroup,
            isNotice: e.isNotice,
            isSecret: e.isSecret,
            id: e.id
          }
        })
        sessionStorage.setItem("localGroupSessionList", JSON.stringify(miniSessionInfo));
        sessionStorage.setItem("localSingleSessionList", JSON.stringify(allSessionList.filter(e => e.sessionType === 1)));
      }
      return {
        ...state,
        allSessionList: [...list],
        aiNoticeSessionList: aiNoticeSessionList
      };
    },
    // ai消息会话列表
    updateAISessionList(state: ChatState, { payload }: any) {
      return {
        ...state,
        aiNoticeSessionList: [...payload.aiNoticeSessionList]
      };
    },
    // 增量修改ai session数据
    updateAISessionDataList(state: ChatState, { payload }: any) {
      const { session } = payload;
      const { aiNoticeSessionList, allSessionList } = state;
      const index = getSessionIndex(aiNoticeSessionList, { sessionId: session.sessionId });
      const allIdx = getSessionIndex(allSessionList, { sessionId: session.sessionId });
      const newState: any = {};
      if (index >= 0) {
        if (session.settings) {
          session.settings = {
            ...aiNoticeSessionList[index].settings,
            ...session.settings
          };
        }
        aiNoticeSessionList[index] = {
          ...aiNoticeSessionList[index],
          ...session
        };
        newState.aiNoticeSessionList = [...aiNoticeSessionList]; // 暂时先更新列表，因为置顶需要同步改变
      }
      if (allIdx >= 0) {
        if (session.settings) {
          session.settings = {
            ...allSessionList[allIdx].settings,
            ...session.settings
          };
        }
        allSessionList[allIdx] = {
          ...allSessionList[allIdx],
          ...session
        };
        newState.allSessionList = [...allSessionList]; // 暂时先更新列表，因为置顶需要同步改变
      }
      return {
        ...state,
        ...newState
      };
    },
    // 更新拉到列表是否已完成状态
    updateSessionListState(state: ChatState, { payload }: any) {
      isSessionLoad = true;
      return {
        ...state,
        loadAllSessionListEnd: true
      };
    },

    // 拉取会话状态
    updateSessionLoadStatus(state: ChatState, { payload }: any) {
      return {
        ...state,
        sessionPage: payload.sessionPage,
        sessionLoadEnd: payload.sessionLoadEnd
      };
    },

    removeSession(state: ChatState, { payload }: any) {
      const { allSessionList, selectedSession } = state;
      const { sessionId } = payload;
      const index = getSessionIndex(allSessionList, { sessionId });
      console.log("getAllSessionList===removeSession===index", index);
      const newState: any = {};
      if (index >= 0) {
        // 物理删除【纵向置顶模式】
        if (payload.force) {
          allSessionList.splice(index, 1);
          newState.allSessionList = [...allSessionList]; // 暂时先更新列表，因为置顶需要同步改变
        } else {
          // 逻辑删除【横向置顶模式】
          allSessionList[index].del = 1;
          // 还要清除未读消息
          allSessionList[index].unreadCount = 0;
          allSessionList[index].mentions = {};
          newState.allSessionList = [...allSessionList];
        }
        console.log("getAllSessionList===removeSession===newState", newState.allSessionList);
      }
      if (selectedSession && sessionId === selectedSession.sessionId) {
        // 移除选中会话的操作
        newState.selectedSession = {};
      }
      if (Object.keys(newState).length > 0) {
        return {
          ...state,
          ...newState
        };
      }
      return state;
    },

    updatePreAISessionMsg(state: ChatState, { payload }: any) {
      const { prevAISessionMessages = [] } = payload;
      state.prevAISessionMessages = [...prevAISessionMessages];
      return state;
    },

    updateConnectState(state: ChatState, { payload }: any) {
      // if (
      //   !isLinuxOs() &&
      //   !navigator.onLine &&
      //   payload.connectState?.state !== ConnectState.OFFLINE
      // ) {
      //   return { ...state };
      // }
      console.log("updateConnectState---", payload.connectState);
      return { ...state, connectState: payload.connectState };
    },

    updateTempMessageStatus(state: ChatState, { payload }: any) {
      const { status, sessionId, id } = payload;
      const tempSessionMessageMap = state.tempSessionMessageMap;
      const tempSessionMessage = tempSessionMessageMap[sessionId] || [];
      // console.log('tempSessionMessage', tempSessionMessage, id, sessionId, status);
      const index = tempSessionMessage.findIndex((item) => item.id === id);
      if (index > -1) {
        tempSessionMessage[index] = { ...tempSessionMessage[index], status };
        tempSessionMessageMap[sessionId] = tempSessionMessage;
        return {
          ...state,
          tempSessionMessageMap: { ...tempSessionMessageMap }
        };
      }
      return state;
    },

    setHistoryMessage(state: ChatState, { payload }: any) {
      const { currentEmployee, tempSessionMessageMap, sessionMessageMap, selectedSession } = state;
      const { sessionId, small, force = false } = payload;
      const isAI = isAINoticeSession(selectedSession);
      const isMerge = selectedSession.isGroup || selectedSession.isMeeting;
      let { historyMessage } = payload;
      let messages: any;
      if (historyMessage?.length) {
        historyMessage = historyMessage.filter((msg: any) => {
          return msg?.type !== "image" || msg?.url;
        });
      }
      if (force) {
        sessionMessageMap[sessionId] = getLatestMessages([...historyMessage]).sort(messageCompare);
        return {
          ...state,
          sessionMessageMap
        };
      }
      const oldSessionMessages = sessionMessageMap[sessionId] || [];
      const tempSessionMessage = (tempSessionMessageMap[sessionId] || []).filter((item) => {
        return isEqualEmployee(item.sender, currentEmployee);
      });
      if ((tempSessionMessage || []).length > 0) {
        oldSessionMessages.push(...tempSessionMessage);
      }
      let mergeMsg = false;
      // 融合群聚合消息撤回重新进入消息重复问题
      if (small) {
        oldSessionMessages.forEach((a) => {
          historyMessage.forEach((b: any) => {
            if (a.plusList && a.content === b.content && a.mid !== b.mid) {
              mergeMsg = true;
            } else {
              mergeMsg = false;
            }
          });
        });

        if (mergeMsg) {
          messages = getLatestMessages([...historyMessage]).sort(messageCompare);
        } else {
          // 解决合并转发消息重复问题
          messages = getLatestMessages([...oldSessionMessages, ...historyMessage]).sort(
            messageCompare
          );
        }
      } else {
        // 解决合并转发消息重复问题
        messages = getLatestMessages([...oldSessionMessages, ...historyMessage]).sort(
          messageCompare
        );
        if (!isAI) {
          // if (isMerge) {
          //   messages = processMessageMerge([...messages])?.mergedMessages;
          // }
          messages = uniqMergedMessage(messages);
          messages = processMessageStatus(selectedSession, messages, currentEmployee);
        }
      }
      sessionMessageMap[sessionId] = messages;
      return {
        ...state,
        sessionMessageMap
      };
    },

    updateMessageUploadState(state: ChatState, { payload }: any) {
      console.log("messageUploadStateMap=>", payload);
      const progress = payload.progress;
      const msgId = payload.msgId;
      const uploadResult = payload.uploadResult || {};
      const messageUploadStateMap = state.messageUploadStateMap;
      const data = messageUploadStateMap[msgId] || {};
      messageUploadStateMap[msgId] = {
        ...data,
        ...{ progress: progress || data.progress, uploadResult }
      };
      console.log("messageUploadStateMap[msgId]=>", messageUploadStateMap[msgId]);
      return {
        ...state,
        messageUploadStateMap: { ...messageUploadStateMap }
      };
    },

    clearMessageUploadState(state: ChatState, { payload }: any) {
      const msgId = payload.msgId;
      const messageUploadStateMap = state.messageUploadStateMap;
      delete messageUploadStateMap[msgId];
      return {
        ...state,
        messageUploadStateMap: { ...messageUploadStateMap }
      };
    },

    clearTempMessage(state: ChatState, { payload }: any) {
      const { sessionId, msgId } = payload;
      const tempSessionMessageMap = state.tempSessionMessageMap;
      const tempSessionMessages = tempSessionMessageMap[sessionId] || [];
      const sessionStatusMap = state.sessionStatusMap;
      // 通过 message 的 id 获取昨时消息是否存在 如果存在临时消息 执行清除操作
      const newTempSessionMessages = tempSessionMessages.filter((item) => item.id !== msgId);
      tempSessionMessageMap[sessionId] = [...newTempSessionMessages];
      delete sessionStatusMap[sessionId];
      return {
        ...state,
        ...sessionStatusMap,
        tempSessionMessageMap: tempSessionMessageMap
      };
    },
    setglobalDrawerVisible(state: ChatState, { payload }: any) {
      return {
        ...state,
        globalDrawerVisible: payload
      };
    },
    setmessageDrawerVisible(state: ChatState, { payload }: any) {
      return {
        ...state,
        messageDrawerVisible: payload
      };
    },
    setappcationApplyMessageId(state: ChatState, { payload }: any) {
      return {
        ...state,
        appcationApplyMessageId: payload
      };
    },
    clearSelectSession(state: ChatState) {
      return {
        ...state,
        setSessionScrollIndex: -1,
        selectedSession: {},
        preSelectedSessionId: "",
        // sessionMessageMap: {},
        administrator: [],
        sub_administrator: [],
        ordinary: [],
        sessionMessages: []
      };
    },
    setImageMessages(state: ChatState, { payload }: any) {
      const filterImageMessages = payload.messages.filter(
        (message: any) => message.type === ChatMessageType.IMAGE
      );
      return {
        ...state,
        imageMessages: filterImageMessages
      };
    },
    setMainWinShow(state: ChatState, { payload }: any) {
      return {
        ...state,
        mainWinShow: payload.show
      };
    },
    updateFilterTabList(state: ChatState, { payload }: any) {
      const { filterTabList } = payload;
      return {
        ...state,
        filterTabList
      };
    },
    setSessionScrollIndex(state: ChatState, { payload }: any) {
      return {
        ...state,
        sessionScrollIndex: payload.sessionScrollIndex
      };
    },
    // 设置截屏类型
    setCaptureType(state: ChatState, { payload }: any) {
      return {
        ...state,
        captureType: payload.captureType
      };
    },
    // 发送消息快捷键
    setMsgtureType(state: ChatState, { payload }: any) {
      return {
        ...state,
        sendMsgType: payload.sendMsgType
      };
    },
    // 组通知详情
    openNoticeDetails(state: ChatState, { payload }: any) {
      const { isvisibles, notificationId, type } = payload;
      return isvisibles
        ? {
            ...state,
            NoticeDetailsVisible: isvisibles,
            notificationId: notificationId,
            type: type
          }
        : {
            ...state,
            NoticeDetailsVisible: false,
            notificationId: "",
            type: ""
          };
    },
    // 组通知历史
    openNoticeDetailsHis(state: ChatState, { payload }: any) {
      const { isvisibles, sessionId } = payload;
      return isvisibles
        ? {
            ...state,
            NoticeHisVisible: isvisibles,
            NoticeDetailsHisId: sessionId
          }
        : {
            ...state,
            NoticeHisVisible: false,
            NoticeDetailsHisId: ""
          };
    },
    // 组接龙详情
    openSolitaireDetails(state: ChatState, { payload }: any) {
      const { isvisibles, solitaire } = payload;
      return isvisibles
        ? {
            ...state,
            SolitaireDetailsVisible: isvisibles,
            solitaireId: solitaire
          }
        : {
            ...state,
            SolitaireDetailsVisible: false,
            solitaireId: ""
          };
    },
    // 组接龙历史
    openSolitaireHis(state: ChatState, { payload }: any) {
      const { isvisibles, solitaireSid } = payload;
      return isvisibles
        ? {
            ...state,
            SolitaireHisVisible: isvisibles,
            solitaireSessionId: solitaireSid
          }
        : {
            ...state,
            SolitaireHisVisible: false,
            solitaireSessionId: ""
          };
    },
    // 数据迁移
    setMigrateVisiable(state: ChatState, { payload }: any) {
      return {
        ...state,
        migrateVisiable: payload.migrateVisiable
      };
    },
    setDbVersion(state: ChatState, { payload }: any) {
      return {
        ...state,
        dbVersion: payload.dbVersion
      };
    },
    updateDownloadingMids(state: ChatState, { payload }: any) {
      return {
        ...state,
        downloadingMids: payload
      };
    },
    updateCustomAppList(state: ChatState, { payload }: any) {
      const { customAppList } = payload;
      // mac横幅提示
      FocusSDK.sendIpcMessage("custom_app_list_change", customAppList);
      return {
        ...state,
        customAppList: customAppList || []
      };
    },
    updateSaveAsCount(state: ChatState, { payload }: any) {
      console.log("updateSaveAsCount=>", payload);
      return {
        ...state,
        saveAsCount: payload
      };
    },
    setSlitaireMap(state: ChatState, { payload }: any) {
      const sessionId = payload.sessionId;
      const a = payload.info;
      const slitaireMap = state.slitaireMap || {};
      if (a) {
        slitaireMap[sessionId] = { ...a };
      } else {
        delete slitaireMap[sessionId];
      }
      return {
        ...state,
        slitaireMap: slitaireMap
      };
    },
    updateQuestionHistory(state: ChatState, { payload }: any) {
      if (!payload) {
        return {
          ...state,
          questionHistory: []
        };
      }
      const { id } = payload;
      const newQuestionHistory = [...state.questionHistory];
      const idx = newQuestionHistory.findIndex((i) => i.id === id);
      if (idx === -1) {
        newQuestionHistory.push(payload);
      } else {
        newQuestionHistory[idx] = {
          ...newQuestionHistory[idx],
          ...payload
        };
      }
      return {
        ...state,
        questionHistory: newQuestionHistory
      };
    },
    setLastUnreadMessage(state: ChatState, { payload }: any) {
      if (!payload) {
        return {
          ...state,
          lastUnreadMessage: {}
        };
      }
      return {
        ...state,
        lastUnreadMessage: payload
      };
    },
    // 更新跨租户通知
    updateOtherTeamNotifyList(state: ChatState, { payload }: any) {
      if (!payload) {
        return {
          ...state,
          otherTeamNotifyList: {}
        };
      }
      const otherList = state.otherTeamNotifyList || {};
      const { originTeamId = "" } = payload;
      if (!otherList[originTeamId]) {
        otherList[originTeamId] = 1;
      } else {
        otherList[originTeamId] = otherList[originTeamId] + 1;
      }
      return {
        ...state,
        otherTeamNotifyList: {
          ...otherList
        }
      };
    },
    // 更新跨租户通知
    updateOtherTeamNotifyListBatch(state: ChatState, { payload }: any) {
      if (!payload?.length) {
        return {
          ...state
        };
      }
      const otherList = state.otherTeamNotifyList || {};
      payload.map((item: any) => {
        const { teamId = "", badge = 0 } = item;
        if (!otherList[teamId]) {
          otherList[teamId] = badge;
        } else {
          otherList[teamId] = badge;
        }
      });
      return {
        ...state,
        otherTeamNotifyList: {
          ...otherList
        }
      };
    },
    updateLLMAgent(state: ChatState, { payload }: any) {
      return {
        ...state,
        llmAgentList: [...payload]
      };
    },
    updateLLMTagsList(state: ChatState, { payload }: any) {
      return {
        ...state,
        llmTagsList: {
          ...payload
        }
      };
    },
    updateLLMSetting(state: ChatState, { payload }: any) {
      return {
        ...state,
        llmSetting: {
          ...payload
        }
      };
    },
    updateLLMInfo(state: ChatState, { payload }: any) {
      if (!payload) {
        return {
          ...state,
          llmInfo: null
        };
      }
      if (payload.images) {
        const oldInfo = state.llmInfo || { images: [] };
        const { images } = payload;
        oldInfo.images = [...images];
        let isReady = oldInfo.images?.filter((i) => i.state !== "completed")?.length === 0;
        return {
          ...state,
          llmInfo: {
            ...oldInfo,
            isReady
          }
        };
      }
      if (payload.files && !payload.isReady) {
        let reay = true;
        payload.files.map((file: any) => {
          if (file.isUpload && file.state !== "completed") {
            reay = false;
          }
        });
        return {
          ...state,
          llmInfo: {
            ...payload,
            isReady: reay
          }
        };
      }
      return {
        ...state,
        llmInfo: {
          ...payload
        }
      };
    },
    // 更新大模型回答问题状态
    updateLLMQuestionInfo(state: ChatState, { payload }: any) {
      return {
        ...state,
        llmQuestionInfo: {
          ...payload
        }
      };
    },
    // 更新智能体
    setCurrentAIRobot(state: ChatState, { payload }: any) {
      return {
        ...state,
        currentAIRobot: payload,
        questionHistory: [] // 清空多轮
      };
    },
    // 更新智能体
    updateCurrentAIRobot(state: ChatState, { payload }: any) {
      const { currentAIRobot } = state;
      return {
        ...state,
        currentAIRobot: {
          ...currentAIRobot,
          ...payload
        }
      };
    }
  },

  effects: {
    // 获取当前会话的图片消息类型
    *getImageMessagesOfCurrentSession({ payload }: any, { put }: any) {
      const imService = ImService.getInstance();
      const params = {
        sessionId: payload.sessionId,
        searchKey: "",
        searchType: ChatMessageType.IMAGE,
        composeVideo: true
      };
      const messages = yield imService.search(params);
      yield put({
        type: "setImageMessages",
        payload: {
          messages
        }
      });
    },
    // 选择消息分类 全部 未读 重要
    *changeNotifyType({ payload: { selectedNotifyType } }: any, { put }: any) {
      yield executePut(put, "updateNotifyType", { selectedNotifyType });
    },
    // 选择类型分类 时间 类别
    *changeCategory({ payload: { selectedCategory } }: any, { put }: any) {
      yield executePut(put, "updateCategory", { selectedCategory });
    },

    *getCurrentEmployee({ payload }: any, { put, select }: any) {
      const imService = ImService.getInstance();
      const currentEmployee = yield imService.getCurrentEmployee(payload);
      yield executePut(put, "setCurrentEmployee", { currentEmployee });
    },

    // 获取所有消息
    *getAllChatSessions({ payload }: any, { put, select }: any) {
      // 用户选择的消息展示选项
      const imService = ImService.getInstance();
      const { options = { offset: 0, count: 20 } } = payload;
      const { allSessionList, page, end } = yield imService.loadSessionPageList(
        { includeDel: 1 },
        false,
        options
      );
      // 筛选出ai助手聚合的session;
      yield executePut(put, "updateSessionList", { allSessionList: allSessionList || [] });
      yield executePut(put, "updateSessionListState", {});
      yield executePut(put, "updateSessionLoadStatus", {
        sessionPage: page,
        sessionLoadEnd: end
      });
      // 更新会话相关的记数
      yield executePut(put, "updateCount", {});
      // 异步处理
      if (options.offset === 0) {
        imService?.getOfflineMessage();
        imService?.getNoticeSessionList();
        imService?.getOrgNoticeSessionList();
      }
    },

    *initAINoitceSessions({ payload }: any, { put, select }: any) {
      const imService = ImService.getInstance();
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const { customAppList, noticeInited, aiNoticeSessionList } = chatState;
      if (noticeInited) {
        return;
      }
      // const aiNoticeList = yield imService.getNoticeSessionList({ noEmit: true });
      const aiIsInit = yield imService.getAppModuleVersion("aiIsInit");
      if (!aiIsInit) {
        const date = Date.now();
        const aiSession = chatState.allSessionList.find((item: Session) =>
          item.sessionId.includes("aiRobot:dd.notice:focus.bot")
        );
        const ext = JSON.parse(aiSession?.ext || "{}");
        const filterList = (ext.filterTabList || []).filter(
          (item: any) => !isCustomAppSessionPin(item?.pin, customAppList)
        );
        if (aiSession?.settings?.shield) {
          const aiSessionPromise = () =>
            sessionSetting(SessionSettingsType.SHIELD, aiSession.sessionId, false);
          const promiseList = [aiSessionPromise];
          const newAiList = aiNoticeSessionList.map((item: Session) => {
            if (!item?.settings?.shield) {
              promiseList.push(() =>
                sessionSetting(SessionSettingsType.SHIELD, item.sessionId, true)
              );
              item.settings = {
                ...item.settings,
                shield: 1
              };
            }
            return item;
          });
          yield executePut(put, "updateAISessionList", {
            aiNoticeSessionList: newAiList
          });
          filterList.forEach((item: any) => {
            const sessionId = imService.generateSingleSessionId(
              {
                app: item.app,
                userId: item.pin,
                teamId: item.teamId
              } as any,
              {
                pin: chatState.currentEmployee.userId,
                app: chatState.currentEmployee.app,
                teamId: chatState.currentEmployee.teamId
              }
            );
            promiseList.push(() => sessionSetting(SessionSettingsType.SHIELD, sessionId, true));
          });
          setTimeout(() => {
            taskQueue.addTasks(promiseList);
          }, 1000);
        }
        imService.setAppVersion(JSON.stringify({ date, version: 1 }), "aiIsInit");
      }
      yield executePut(put, "updateCustomAppList", {
        customAppList
      });
    },

    // 清空聊天记录
    *clearSessionMessage({ payload }: any, { put, select }: any) {
      const { sessionId } = payload;
      if (sessionId.indexOf(CHAT_NOTICE.AI_PIN) > -1) {
        yield executePut(put, "clearAISessionAllMessage", payload);
      } else {
        const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
        const { sessionMessageMap, currentEmployee } = chatState;
        if (sessionId.indexOf(NOTICE_APP) > -1) {
          const aiSessionId = `aiRobot:dd.notice:focus.bot:${convertEmployeeToString(
            currentEmployee
          )}`;
          if (sessionMessageMap[aiSessionId]?.length) {
            const newAiSessionMessages =
              sessionMessageMap[aiSessionId].filter(
                (item: { requestData: { sessionId: any } }) =>
                  item.requestData.sessionId !== sessionId
              ) || [];
            sessionMessageMap[aiSessionId] = newAiSessionMessages;
          }
        }
        // yield executePut(put, "updateSessionMessage", { sessionMessageMap });
        yield executePut(put, "clearSessionAllMessage", payload);
      }
    },
    *dealStopQuestions({ payload }: any, { put, select }: any) {
      if (payload?.id) {
        yield messageStop({
          requestId: payload?.id
        });
        yield sleep(300);
      }
      if (payload?.nextChat) {
        const aiSessionId = yield getAIChatSessionId();
        yield ImService.getInstance()?.sendSystemMessage(
          aiSessionId,
          {
            content: "开启新会话",
            type: ChatMessageType.SYS,
            flag: 11010
          },
          {
            skipCheckSession: true,
            noSend: true
          }
        );
        yield executePut(put, "updateQuestionHistory", null);
      }
      // 更新回答状态为停止
      yield executePut(put, "updateLLMQuestionInfo", {
        questionId: payload?.id,
        status: LLMMessageStatus.STOP
      });
      // yield executePut(put, "updateLLMInfo", null);
    },
    // 更新智能体
    *resetCurrentAIRobot({ payload }: any, { put, select }: any) {
      const { messageId, agentInfo } = payload;
      yield executePut(put, "dealStopQuestions", {
        id: messageId
      });
      yield executePut(put, "setCurrentAIRobot", agentInfo);
    },
    /**
     * 接收一条新消息 交给 ImService 处理
     * @param chatMessage
     * @param put
     * @param select
     */
    // eslint-disable-next-line complexity
    *receiveSessionNewMessage({ payload: { chatMessage } }: any, { put, select }: any) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const userState = yield select(({ user }: { user: UserState }) => user);
      const show = chatState.mainWinShow;
      // mebjJZB-235跨租户通知
      // if (chatMessage.category === MessageReqType.OTHER_TEAM_MSG) {
      //   const { originTeamId } = chatMessage;
      //   if (originTeamId) {
      //     yield executePut(put, "updateOtherTeamNotifyList", {
      //       originTeamId,
      //       num: 1
      //     });
      //   }
      //   return;
      // }
      // mebjJZB-236跨租户角标通知
      if (chatMessage.category === MessageReqType.TEAM_BADGE_MSG) {
        const { teamBadgeChangeList = [] } = chatMessage;
        if (teamBadgeChangeList?.length) {
          yield executePut(put, "updateOtherTeamNotifyListBatch", teamBadgeChangeList);
        }
        return;
      }
      Bus.emit("calendar_im_message", chatMessage);
      if (
        chatMessage.sessionId === chatState.selectedSession.sessionId &&
        chatMessage.type === "message_tag"
      ) {
        const [data] = yield getMessageTagPageList({
          pageNo: 1,
          pageSize: 10,
          groupId: chatMessage?.sessionId
        });
        let tempArr: any[] = [];
        data?.list &&
          Array.isArray(data?.list) &&
          data?.list.length > 0 &&
          // eslint-disable-next-line array-callback-return
          data.list.map((item: any, index: number) => {
            // 只取前三条
            if (index < 3) {
              tempArr.push(item);
            }
          });
        yield executePut(put, "setShowTagList", [...tempArr]);
      }
      if (chatMessage.statusType === MessageStatus.FAILED && chatMessage.localSendTimestamp) {
        if (!chatMessage.belong && !chatMessage.sender?.userId) {
          chatMessage.sender = { ...chatMessage.sender, ...chatState.currentEmployee };
        }
      }
      // 未读总结消息
      if (isUnreadSummarySysMesssage(chatMessage)) {
        yield executePut(put, "setLastUnreadMessage", chatMessage);
        return;
      }
      // 接收当前会话新消息
      const imService = ImService.getInstance();
      // console.log('接收到一条新消息', chatMessage);
      const { selectedSession = {}, customAppList, questionHistory } = chatState;
      const originSessionId = chatMessage?.requestData?.sessionId;
      if (customAppList.findIndex((item: Session) => item.sessionId === originSessionId) > -1) {
        chatMessage.sessionId = originSessionId;
      }
      const { teamConfig } = userState;
      const opts = {
        keywords: (teamConfig?.aiMergeKeywords || "").split(","),
        duration: Number(teamConfig?.aiMergeDuration || "3600000"),
        aiMergeLocal: teamConfig?.aiMergeLocal || false,
        aiMergeRule: teamConfig?.aiMergeRule || {}
      };
      const result = yield dealSessionNewMessage(chatState, chatMessage, opts);
      // eslint-disable-next-line no-debugger
      const currentSessionId = chatState.selectedSession && chatState.selectedSession.sessionId;
      const currentMessageSessionId = chatMessage?.sessionId;
      if (result.changed) {
        // console.log('chatMessage => ', chatMessage);
        // 当前会话是否为ai助手，如果是需判断接收的消息是否为ai助手的集合消息，然后控制读取
        if (
          selectedSession.isNotice &&
          isAINoticeSession(selectedSession) &&
          !isAIChatSessionId(selectedSession?.sessionId)
        ) {
          chatMessage.info = {
            userId: chatMessage?.infox?.noticeId || chatMessage.from.pin
          };
          if (
            isAINoticeChildSessionMessage(chatMessage, customAppList) &&
            !isSysMessage(chatMessage)
          ) {
            const _chatMessage = {
              ...chatMessage,
              sessionId: chatMessage?.requestData?.sessionId
            };
            // console.log('AI助手接收到一条新消息', _chatMessage);
            imService.readOneMessage(_chatMessage).then(() => {
              if (_chatMessage.extend.bizId && _chatMessage.extend.readRecord === true) {
                addBatchViewCardRead([_chatMessage]);
              }
            });
          }
        } else if (currentMessageSessionId === currentSessionId && show) {
          // imService.readOneMessage(chatMessage).then();
          // 群解散之后再发消息给出提示
          if (
            chatMessage.statusType === MessageStatus.FAILED &&
            chatMessage.localSendTimestamp &&
            chatMessage.sessionId &&
            chatMessage.sessionId.indexOf(":") === -1 &&
            !isMeetingSessionId(chatMessage.sessionId) &&
            !isLiveMeetingSessionId(chatMessage.sessionId)
          ) {
            yield getGroupInfo({
              groupIds: [{ groupId: chatMessage.sessionId || chatMessage.gid || "" }]
            })
              .then((res) => {
                if (res?.groups && res?.groups[0]?.flag !== 3) {
                  // message.error("该组已解散！");
                }
              })
              .catch((err) => {
                console.error("发送消息失败----err", err);
              });
          }
        }
        const sessionMessageMap = result.sessionMessageMap;
        yield executePut(put, "updateSessionMessage", { sessionMessageMap });
        // 同步IM
        if (chatMessage.flag === LLMMessageStatus.END) {
          if (chatMessage.type === ChatMessageType.TEMPLATE2 && !chatMessage.template) {
            return;
          }
          if (result.newMessage?.rawQuestionId) {
            chatMessage["questionId"] = result.newMessage?.rawQuestionId;
          }
          if (!isHomePageUrl() && chatMessage.mid === 0) {
            try {
              yield messagePush({
                id: chatMessage.id,
                aid: "",
                type: "chat_message",
                ver: "4.3",
                lang: "zh_CN",
                timestamp: new Date().getTime(),
                to: employeeToUid(chatState.currentEmployee),
                body: { ...omit(cloneDeep(chatMessage), ["flag"]), offlinePush: 0, needDetect: 0 }
              });
            } catch (e) {}
          }
          if (questionHistory?.length > 5) {
            yield executePut(put, "updateQuestionHistory", null);
          }
          if (chatMessage.history) {
            yield executePut(put, "updateQuestionHistory", chatMessage.history);
          }
          // 清除状态
          yield executePut(put, "updateLLMQuestionInfo", {});
        }
      }
      if (
        chatMessage.type === MessageStatus.GROUPDELETE &&
        chatMessage.sessionId === currentSessionId
      ) {
        Bus.emit("chat:group_delete", chatMessage.sessionId);
      }
      // 擦除消息
      if (isGroupCleanMessage(chatMessage) && selectedSession.sessionId === chatMessage.sessionId) {
        yield executePut(put, "updateSelectSessionInfo", {
          session: {
            sessionId: selectedSession.sessionId,
            unreadCountFork: 0,
            unnreadCountPseudo: 0
          }
        });
      }
    },

    /**
     * 接收自定义应用配置变更消息
     * @param chatMessage
     * @param put
     * @param select
     */
    *receiveCustomAppConfigMessage({ payload: { chatMessage } }: any, { put, select }: any) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const { currentEmployee, allSessionList, selectedSession } = chatState;
      yield executePut(put, "getCustomNoticeSession", { isEmit: true });
    },

    /**
     * 接收到批量消息
     * @param chatMessages
     * @param put
     * @param select
     */
    *receiveOneSessionBatchMessage(
      { payload: { chatMessages, sessionId } }: any,
      { put, select }: any
    ) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const userState = yield select(({ user }: { user: UserState }) => user);
      const show = chatState.mainWinShow;
      const currentSessionId = chatState.selectedSession?.sessionId;
      const currentEmployee = chatState.currentEmployee;
      // 接收当前会话新消息
      const len = chatMessages.length;
      if (!len) {
        return;
      }
      const { teamConfig } = userState;
      const opts = {
        keywords: (teamConfig?.aiMergeKeywords || "").split(","),
        duration: Number(teamConfig?.aiMergeDuration || "3600000"),
        aiMergeLocal: teamConfig?.aiMergeLocal || false,
        aiMergeRule: teamConfig?.aiMergeRule || {}
      };
      const imService = ImService.getInstance();
      const result = yield dealSessionBatchMessage(chatState, chatMessages, sessionId, opts);
      if (result.changed) {
        const sessionMessageMap = result.sessionMessageMap;
        yield executePut(put, "updateSessionMessage", { sessionMessageMap });
        yield executePut(put, "updateSessionMessagesTimestamp", {
          timestamp: new Date().getTime()
        });
        // if (sessionId === currentSessionId && show) {
        //     chatMessages.forEach((m: any) => {
        //         if (!isEqualEmployee(m.sender, currentEmployee) && !m.isRead) {
        //             imService.readOneMessage(m).then();
        //         }
        //     });
        // }
      }
    },

    *receiveSessionBatchMessage({ payload: { chatMessages } }: any, { put, select }: any) {
      // 接收当前会话新消息
      const len = chatMessages.length;
      if (!len) {
        return;
      }
      const groups = lodashGroupBy(chatMessages, "sessionId");
      for (const key of Object.keys(groups)) {
        yield executePut(put, "receiveOneSessionBatchMessage", {
          chatMessages: groups[key],
          sessionId: key
        });
      }
    },

    *deleteSessionMessage({ payload }: any, { put, select }: any) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const { sessionMessageMap, selectedSession } = chatState;
      const message = payload.message as ChatMessage;
      const sessionMessage = sessionMessageMap[message.sessionId];
      remove(sessionMessage, (item: ChatMessage) => {
        return item.id === message.id;
      });
      if (selectedSession.isGroup) {
        const result = yield dealMessageMerged(selectedSession, sessionMessage);
        sessionMessageMap[message.sessionId] = [...result];
      } else {
        sessionMessageMap[message.sessionId] = sessionMessage;
      }
      yield executePut(put, "updateSessionMessage", { sessionMessageMap });
    },

    *destroySessionMessage({ payload }: any, { put, select }: any) {
      for (let message of payload.messages) {
        // console.log(66666, message);
        yield executePut(put, "deleteSessionMessage", { message });
      }
      yield executePut(put, "updateMessages", { messages: [] });
      yield executePut(put, "changeSelectMore", { selectMore: false });
    },

    // 选中会话进行的操作
    // *selectOneSession({ payload: { selectedSession } }: any, { put, select }: any) {
    //     const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
    //     // 设置当前会话
    //     yield executePut(put, 'initSelectedSession', { selectedSession });
    // },

    // 更新选中会话信息
    *updateSelectSessionInfo({ payload: { session } }: any, { put, select }: any) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const { selectedSession } = chatState;
      if (selectedSession?.sessionId !== session?.sessionId) {
        return false;
      }
      // 设置当前会话
      yield executePut(put, "updateSelectedSession", {
        selectedSession: {
          ...selectedSession,
          ...session
        }
      });
    },

    *loadSessionMembers({ payload: { selectedSession } }: any, { put, select }: any) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const imService = ImService.getInstance();
      const { currentEmployee } = chatState;
      console.log("loadSessionMembers");
      if (selectedSession.isGroup) {
        // 群组会话
        const rosters = yield imService.getGroupRosterInfo(selectedSession.sessionId, true);
        // console.log('lyj---loadSessionMembers', selectedSession);
        // const rosters = Object.values(selectedSession.info.rosters);
        if (rosters && rosters.length > 0) {
          const data = lodashGroupBy(rosters, "identity");
          // const data = lodashGroupBy(mapRosters(rosters), 'identity');
          // console.log('分组', data);
          yield executePut(put, "updateGroupRosters", {
            administrator: data.administrator || [],
            sub_administrator: data.sub_administrator || [],
            ordinary: data.ordinary || [],
            groupMemberSessionId: selectedSession.sessionId
          });
        }
      } else if (selectedSession.isSingle) {
        if (toMe({ session: selectedSession, employee: currentEmployee })) {
          yield executePut(put, "updateSessionMembers", { sessionMembers: [] });
          return;
        }
        // 单人会话
        const sessionMembers = yield imService.getSingleMembers(selectedSession, currentEmployee);
        yield executePut(put, "updateSessionMembers", {
          sessionMembers: [...sessionMembers]
        });
      }
    },

    *launchGroupSession(
      { payload: { sid, top, sMid, sText, sTimestamp } }: any,
      { put, select }: any
    ) {
      console.log("getAllSessionList===端上launchGroupSession");
      if (!sid) {
        return null;
      }
      const imService = ImService.getInstance();
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const { selectedSession, connectState } = chatState;
      // 拉起会话， 如果会话id 与 当前 selectedSession 的id相同
      if (sid === selectedSession.sessionId) {
        return null;
      }
      const allSessionList = chatState.allSessionList || [];
      let index = -1;
      if (chatState.allSessionList?.length > 0) {
        index = getSessionIndex(chatState.allSessionList, { sessionId: sid });
      }
      let session = allSessionList[index];
      console.log("getAllSessionList===imService.launchGroupSessio===", session);
      if (!session || isInValidSessionInfo(session) || top) {
        // 先获取群会话
        console.log("getAllSessionList===imService.launchGroupSession", session, top);

        session = yield imService.launchGroupSession(sid);
      }
      if (!session) {
        return null;
      }
      if (sMid) {
        yield executePut(put, "setStartMessageId", { sMid, sText, sTimestamp });
      } else {
        yield executePut(put, "setStartMessageId", {
          sMid: -1,
          sText: "",
          sTimestamp: 0,
          skipAnchorId: {}
        });
      }
      // 清空状态
      yield executePut(put, "setShowTagList", []);
      // session.unreadCount = 0;
      // session.mentions = {};
      // session.lastReadMid = session.lastMid || 0;
      // session.attentionCount = 0;
      // Bus.emit(`chat:session-update:${session.sessionId}`, session);
      session.unreadCountFork = session.unreadCount;
      session.unnreadCountPseudo = session.unreadCount;
      session.lastReadMidFork = session.lastReadMid;
      yield executePut(put, "initSelectedSession", { selectedSession: session });
      yield executePut(put, "updateGroupRosters", {
        administrator: [],
        sub_administrator: [],
        ordinary: [],
        groupMemberSessionId: ""
      });

      // 去缓存中查一下
      if (!session.info || !session.info.flag) {
        let group = yield imService.getGroup(session.sessionId);
        if (!group?.name || !group?.flag) {
          let groupInfo = yield getGroupInfo({
            groupIds: [{ groupId: session.sessionId || session.gid || "" }]
          }).catch((err) => {
            console.error("reloadSession-err", err);
            return { groups: [] };
          });
          if (groupInfo?.groups) {
            group = groupInfo.groups[0] || {};
          }
        }
        session.info = group || {};
      }
      // 更新信息
      yield executePut(put, "updateSelectSessionInfo", { session });
      yield executePut(put, "loadSessionMembers", { selectedSession: session });
      // 检测是否在组
      // 判断info
      if (session.info && session.info.flag && session.info.flag !== 3) {
        // AntMessage.error("该组已解散", 2);
        yield executePut(put, "updateSessionList", { allSessionList });
        yield executePut(put, "updateSelectSessionInfo", { session });
        return null;
      } else if (connectState?.state === ConnectState.READY) {
        try {
          let _group;
          const _groupInfo = yield getGroupInfo({
            groupIds: [{ groupId: session.sessionId || session.gid || "" }]
          }).catch((err) => {
            console.error("getGroupInfo----err", err);
          });
          if (_groupInfo?.groups) {
            _group = _groupInfo.groups[0] || undefined;
          }
          if (_group) {
            session.info = { ..._group, rosters: session.info?.rosters };
            yield executePut(put, "updateSelectSessionInfo", { session });
          }
          if (_group && _group.flag !== 3) {
            // AntMessage.error("该组已解散", 2);
            return null;
          }
          // 初始化加载组机器人
          yield executePut(put, "loadGroupRobots", { session });
        } catch (e) {
          console.error("launchGroupSession checkInGroup error: ", e);
        }
      }
      if (index < 0) {
        // 解决[bug] 群聊重复 --hujun
        const isExistence = allSessionList.some((item: { id: any }) => {
          if (session && item.id === session.id) {
            return true;
          }
          return false;
        });
        // 如果session不存在allSessionList中则添加
        if (!isExistence) {
          if (top) {
            session.timestamp = Date.now();
          }
          allSessionList.push(session);
        }
        // 解决[bug] 群聊重复 --end
        yield executePut(put, "reSortAllSessionList", {
          allSessionList: allSessionList
        });
        return;
      }
      if (top && index > 0) {
        // 如果需要置定并且存在当前的会话列表 列表进行重新排序
        allSessionList[index].timestamp = Date.now();
        // 点击会话列表中没有的置顶会话，isExistence为true，此时只修改del状态，设置session的del为0-----xly
        console.log("getAllSessionList===isExistence");
        allSessionList[index].del = 0;
        yield executePut(put, "reSortAllSessionList", {
          allSessionList: allSessionList
        });
      }
      yield ImService.getInstance()?.setCurrentSession(session.sessionId);
      return true;
    },
    *launchNoticeSession({ payload: { sid, top } }: any, { put, select }: any) {
      if (!sid) {
        return;
      }
      const { chat: chatState, user: userState } = yield select(
        ({ chat, user }: { chat: ChatState; user: UserState }) => {
          return {
            chat,
            user
          };
        }
      );
      const { selectedSession, aiNoticeSessionList } = chatState;
      if (sid === selectedSession.sessionId) {
        return;
      }
      const sids = sid.split(":");
      const newSid = sids.slice(0, 6).join(":");
      const allSessionList = chatState.allSessionList;
      let index = -1;
      if (chatState.allSessionList?.length > 0) {
        index = getSessionIndex(chatState.allSessionList, { sessionId: newSid });
      }
      let session = allSessionList[index];
      const imService = ImService.getInstance();
      if (!session || isInValidSessionInfo(session)) {
        session = yield imService.loadNoticeSession(newSid);
      }
      if (sids.length === 7) {
        session = {
          ...session,
          sessionId: sid
        };
      }
      if (session && !isInValidSessionInfo(session)) {
        if (isAINoticeSession(session) && isHomePageUrl()) {
          yield executePut(put, "initAINoitceSessions", {});
          if (!chatState.filterTabList.length) {
            const { filterTabList = [] } = session.ext ? JSON.parse(session.ext) : {};
            const newFilterTabList: any[] = [];
            filterTabList.forEach((item: { pin: string }) => {
              if (chatState.customAppList.findIndex((itm: any) => itm.appKey === item.pin) === -1) {
                newFilterTabList.push(item);
              }
            });
            yield executePut(put, "updateFilterTabList", {
              filterTabList: [...newFilterTabList]
            });
          }
          session.timestamp = computeAITimestamp(aiNoticeSessionList);
          const res = computeAIUnReadInfo(aiNoticeSessionList);
          session = {
            ...session,
            ...res
          };
          session.unreadCountFork = session.unreadCount;
          session.unnreadCountPseudo = session.unreadCount;
          session.lastReadMidFork = session.lastReadMsg?.mid;
          session.lastReadIdFork = session.lastReadMsg?.id;
          if (session.unreadCountFork > 0 && userState.readMsgCustom === "first") {
            yield executePut(put, "setStartMessageId", {
              sMid: session.lastReadMidFork,
              skipAnchorId: {}
            });
          }
        }
        yield executePut(put, "initSelectedSession", {
          selectedSession: session
        });
        // 异步更新头像
        const { info } = session;
        const { app, userId, teamId } = info || {};
        if (!session.sessionId.includes(CHAT_NOTICE.AI_PIN)) {
          imService.getEmployeeDetail({
            appId: app,
            userId,
            teamId
          });
        }
      } else {
        return;
      }
      if (top && index > 0) {
        // 如果需要置定并且存在当前的会话列表 列表进行重新排序
        allSessionList[index].timestamp = Date.now();
        yield executePut(put, "reSortAllSessionList", {
          allSessionList: allSessionList
        });
      }
      yield ImService.getInstance()?.setCurrentSession(session.sessionId);
    },
    *launchOrgNoticeSession(
      { payload: { sid, top, type = "0", user } }: any,
      { put, select }: any
    ) {
      console.log("getAllSessionList===端上launchOrgNoticeSession");
      if (!sid && !user) {
        return;
      }
      let _sid = sid;
      const imService = ImService.getInstance();
      const { chat: chatState, user: userState } = yield select(
        ({ chat, user }: { chat: ChatState; user: UserState }) => {
          return {
            chat,
            user
          };
        }
      );
      let st = SessionType.ORG_BROADCAST;
      if (type) {
        try {
          st = Number(type) === 1 ? SessionType.ORG_NORMAL : SessionType.ORG_BROADCAST;
        } catch (e) {}
      }
      const { selectedSession, currentEmployee } = chatState;
      if (!sid && user) {
        _sid = imService.generateSingleSessionId(currentEmployee, user, st);
      }
      if (!_sid) {
        return;
      }
      if (_sid === selectedSession.sessionId) {
        return;
      }
      // const sids = sid.split(":");
      // const newSid = sids.slice(0, 6).join(":");
      const allSessionList = chatState.allSessionList;
      let index = -1;
      if (chatState.allSessionList?.length > 0) {
        index = getSessionIndex(chatState.allSessionList, { sessionId: _sid });
      }
      let session = allSessionList[index];
      if (!session || isInValidSessionInfo(session)) {
        session = yield imService.loadOrgNoticeSession(_sid, st);
      }
      if (session && !isInValidSessionInfo(session)) {
        yield executePut(put, "initSelectedSession", {
          selectedSession: session
        });
      } else {
        return;
      }
      if (top && index > 0) {
        // 如果需要置定并且存在当前的会话列表 列表进行重新排序
        allSessionList[index].timestamp = Date.now();
        // 点击会话列表中没有的置顶会话，isExistence为true，此时只修改del状态，设置session的del为0-----xly
        console.log("getAllSessionList===isExistence");
        allSessionList[index].del = 0;
        yield executePut(put, "reSortAllSessionList", {
          allSessionList: allSessionList
        });
      }
      yield ImService.getInstance()?.setCurrentSession(session.sessionId);
    },
    *launchAINoticeTabSession({ payload: { pin, sessionId, top } }: any, { put, select }: any) {
      if (!pin) {
        return;
      }
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const { selectedAITab } = chatState;
      if (pin === selectedAITab.pin) {
        return;
      }
      yield executePut(put, "initSelectedAITab", { selectedAITab: { pin, sessionId } });
    },
    *launchSingleSession(
      {
        payload: { user, top, type, sMid, sText, sTimestamp }
      }: {
        payload: {
          user: UID;
          top?: boolean;
          type: any;
          sMid?: number;
          sText?: string;
          sTimestamp?: number;
        };
      },
      { put, select }: any
    ) {
      console.log("getAllSessionList===端上launchSingleSession", top);

      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const { selectedSession, currentEmployee } = chatState;
      if (selectedSession.isSingle && !selectedSession.isNotice) {
        const info = selectedSession.info as Employee;
        // 和同一个人聊天 普通聊天和密聊切换会话，不走这里
        if (
          isEqualUid(employeeToUid(info), user) &&
          type === SessionType.SINGLE &&
          !selectedSession.isSecret
        ) {
          yield executePut(put, "initSelectedSession", {
            selectedSession: selectedSession
          });
          return;
        }
      }
      const imService = ImService.getInstance();
      const allSessionList = chatState.allSessionList || [];
      let index = -1;
      // tj: 保证大于一屏可以自动排序
      if (allSessionList?.length > 0) {
        const sid = imService.generateSingleSessionId(currentEmployee, user, type);

        index = getSessionIndex(allSessionList, { sessionId: sid });
      }
      let session = allSessionList[index];
      if (!session || top) {
        // console.log('创建单聊');
        console.log("getAllSessionList===创建单聊");

        // 创建单聊session
        session = yield imService.createSingleSession(user, type);

        // 解决[bug] 单聊重复 --hujun
        const isExistence = allSessionList.some((item: { id: any }) => {
          if (session && item.id === session.id) {
            return true;
          }
          return false;
        });
        if (session && !isInValidSessionInfo(session) && !isExistence) {
          allSessionList.push(session);
        }
        // 解决[bug] 单聊重复 --end
        if (!isExistence) {
          if (top) {
            session.timestamp = Date.now();
            // 修改imsdk中session的del字段为0
          }
          yield executePut(put, "reSortAllSessionList", {
            allSessionList: allSessionList
          });
        }
      }

      if (!session || isInValidSessionInfo(session || {})) {
        return;
      }
      if (sMid) {
        yield executePut(put, "setStartMessageId", { sMid, sText, sTimestamp });
      } else {
        yield executePut(put, "setStartMessageId", {
          sMid: -1,
          sText: "",
          sTimestamp: 0,
          skipAnchorId: {}
        });
      }
      // 清空状态
      // session.unreadCount = 0;
      // session.mentions = {};
      // session.lastReadMid = session.lastMid || 0;
      // session.attentionCount = 0;
      // Bus.emit(`chat:session-update:${session.sessionId}`, session);
      session.unreadCountFork = session.unreadCount;
      session.unnreadCountPseudo = session.unreadCount;
      session.lastReadMidFork = session.lastReadMid;
      yield executePut(put, "initSelectedSession", { selectedSession: session });
      yield sleep(20);
      yield executePut(put, "loadSessionMembers", { selectedSession: session });
      // console.log('拉起单聊', allSessionList, session);
      if (index > 0 && top) {
        // 如果需要置定并且存在当前的会话列表 列表进行重新排序
        allSessionList[index].timestamp = Date.now();
        // 点击会话列表中没有的置顶会话，isExistence为true，此时只修改del状态，设置session的del为0-----xly
        console.log("getAllSessionList===isExistence");
        allSessionList[index].del = 0;
        yield executePut(put, "reSortAllSessionList", {
          allSessionList: allSessionList
        });
      }
      yield ImService.getInstance()?.setCurrentSession(session.sessionId);
    },
    *launchMeetingSession({ payload: { sid, top } }: any, { put, select }: any) {
      if (!sid) {
        return null;
      }
      const imService = ImService.getInstance();
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const { selectedSession } = chatState;
      const allSessionList = chatState.allSessionList || [];
      let index = -1;
      if (chatState.allSessionList?.length > 0) {
        index = getSessionIndex(chatState.allSessionList, { sessionId: sid });
      }
      let session = allSessionList[index];
      if (!session) {
        // 先获取群会话
        session = yield imService.launchMeetingSession(sid);
      }
      if (!session) {
        return null;
      }
      // 获取权限
      const { chatType = 0 } = yield getChatPermission({
        meetingCode: getChatMeetingCode(session.sessionId)
      });
      session.settings = {
        ...session.settings,
        permissionEnum: chatType
      };
      yield executePut(put, "initSelectedSession", { selectedSession: session });
      yield executePut(put, "updateGroupRosters", {
        administrator: [],
        sub_administrator: [],
        ordinary: [],
        groupMemberSessionId: ""
      });
      // 更新信息
      yield executePut(put, "updateSelectSessionInfo", { session });
      // 获取人员
      FocusSDK.sendJdmtEvent({
        channel: "getUsers"
      });
      // 设置已读
      FocusSDK.sendJdmtEvent({
        channel: "onload",
        data: { sessionId: sid }
      });
      // yield executePut(put, "loadSessionMembers", { selectedSession: session });
      // 检测是否在组
      if (index < 0) {
        // 解决[bug] 群聊重复 --hujun
        const isExistence = allSessionList.some((item: { id: any }) => {
          if (session && item.id === session.id) {
            return true;
          }
          return false;
        });
        // 如果session不存在allSessionList中则添加
        if (!isExistence) {
          allSessionList.push(session);
        }
        // 解决[bug] 群聊重复 --end
        yield executePut(put, "updateSessionList", { allSessionList });
        return;
      }
      // console.log('拉取群组', allSessionList, session);
      if (top && index > 0) {
        // 如果需要置定并且存在当前的会话列表 列表进行重新排序
        allSessionList[index].timestamp = Date.now();
        yield executePut(put, "reSortAllSessionList", {
          allSessionList: allSessionList
        });
      }
      return true;
    },
    *launchLiveMeetingSession({ payload: { sid, top } }: any, { put, select }: any) {
      if (!sid) {
        return null;
      }
      const imService = ImService.getInstance();
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const { selectedSession } = chatState;
      const allSessionList = chatState.allSessionList || [];
      let index = -1;
      if (chatState.allSessionList?.length > 0) {
        index = getSessionIndex(chatState.allSessionList, { sessionId: sid });
      }
      let session = allSessionList[index];
      if (!session) {
        // 先获取群会话
        session = yield imService.launchLiveMeetingSession(sid);
      }
      if (!session) {
        return null;
      }
      // 获取权限
      const { chatPermission = 0 } = yield getLiveChatPermission({
        conferenceCode: getLiveChatMeetingCode(session.sessionId)
      });
      session.settings = {
        ...session.settings,
        permissionEnum: chatPermission
      };
      yield executePut(put, "initSelectedSession", { selectedSession: session });
      yield executePut(put, "updateGroupRosters", {
        administrator: [],
        sub_administrator: [],
        ordinary: [],
        groupMemberSessionId: ""
      });
      // 更新信息
      yield executePut(put, "updateSelectSessionInfo", { session });
      if (!sid.startsWith("live-")) {
        // 直播聊天不需要
        // 获取人员
        FocusSDK.sendJdmtEvent({
          channel: "getUsers"
        });
        // // 设置已读
        FocusSDK.sendJdmtEvent({
          channel: "onload",
          data: { sessionId: sid }
        });
      }
      // yield executePut(put, "loadSessionMembers", { selectedSession: session });
      // 检测是否在组
      if (index < 0) {
        // 解决[bug] 群聊重复 --hujun
        const isExistence = allSessionList.some((item: { id: any }) => {
          if (session && item.id === session.id) {
            return true;
          }
          return false;
        });
        // 如果session不存在allSessionList中则添加
        if (!isExistence) {
          allSessionList.push(session);
        }
        // 解决[bug] 群聊重复 --end
        yield executePut(put, "updateSessionList", { allSessionList });
        return;
      }
      // console.log('拉取群组', allSessionList, session);
      if (top && index > 0) {
        // 如果需要置定并且存在当前的会话列表 列表进行重新排序
        allSessionList[index].timestamp = Date.now();
        yield executePut(put, "reSortAllSessionList", {
          allSessionList: allSessionList
        });
      }
      return true;
    },
    *updateSessionMessageMid(
      {
        payload: {
          sessionId,
          sendResult,
          force = false,
          saveLocal = false,
          picksKey = ["mid", "timestamp", "status", "flag"]
        }
      }: any,
      { put, select }: any
    ) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const sessionMessageMap = chatState.sessionMessageMap;
      const sessionMessage = sessionMessageMap[sessionId] || [];
      const messageBody = sendResult.body;
      const msgIndex = findLastIndex(
        sessionMessage,
        (item: ChatMessage) => item.id === messageBody.id
      );
      Object.assign(messageBody, lodashPick(sendResult, picksKey));
      if (msgIndex > -1) {
        const msg = sessionMessage[msgIndex];
        const newMsg = { ...msg, ...messageBody };
        sessionMessage[msgIndex] = newMsg;
        const url = messageBody.url || msg.url;
        if (url) {
          sessionMessage[msgIndex].url = url;
        }
        sessionMessageMap[sessionId] = [...sessionMessage.sort(messageCompare)];
        yield executePut(put, "updateSessionMessage", {
          sessionMessageMap
        });
        // yield executePut(put, 'updateSessionMessagesTimestamp', {
        //     timestamp: new Date().getTime(),
        // });
        if (saveLocal) {
          const mid = newMsg.id;
          yield ImService.getInstance()?.updateMessageById(sessionId, mid, newMsg);
        }
      } else if (force) {
        sessionMessage.push(messageBody);
        sessionMessageMap[sessionId] = [...sessionMessage];
        yield executePut(put, "updateSessionMessage", {
          sessionMessageMap
        });
      }
    },

    *upsertSession({ payload }: any, { put, select, call }: any) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      if (!chatState.loadAllSessionListEnd) {
        return;
      }
      let { session } = payload;
      const isCustomApp = session.isCustomApp;
      // 过滤不需要的会话更新
      if (isUnnecessarySession(session)) {
        return;
      }
      const isAIChat = yield isAIChatSessionId(session.sessionId);
      if (isAIChat) {
        return;
      }
      if (session && !session.timestamp) {
        session.timestamp = Date.now();
      }
      let allSessionList = [...(chatState.allSessionList || [])];
      const selectedSession = chatState.selectedSession || {};
      const currentEmployee = chatState.currentEmployee || {};
      const customAppList = [...(chatState.customAppList || [])];
      const filterTabList = chatState.filterTabList || [];
      const selectedAITab = chatState.selectedAITab || {};
      const selectedSessionId = selectedSession.sessionId;
      const skipAnchorId = chatState.currentEmployee || {};
      // 更新session时。如果没有时间戳 或者名称 或者头像的
      if (isInValidSessionInfo(session)) {
        const imService = ImService.getInstance();

        session = yield call(imService.reloadSession.bind(imService), session);
        if (isInValidSessionInfo(session)) {
          return;
        }
      }
      session = lodashPick(session, sessionAttrs);
      // 更新会话
      if (selectedSessionId === session.sessionId) {
        if (session.unreadCount && !skipAnchorId?.msgId) {
          session.lastReadMidFork = session.lastReadMid;
          session.unreadCountFork = session.unreadCount;
        }
        let rosters = session.info.rosters || {};
        if (!Object.keys(rosters).length) {
          rosters = selectedSession.info.rosters;
        }
        session.info = { ...session.info, rosters, flag: (selectedSession.info as any).flag };
        // 会议更新主持人
        if (isMeetingSessionId(session.sessionId)) {
          const rawSetting = selectedSession.settings;
          const newSetting = session.settings;
          if (rosters) {
            const arr = values(rosters);
            const data = lodashGroupBy(arr, "identity");
            yield executePut(put, "updateGroupRosters", {
              administrator: data.administrator || [],
              sub_administrator: data.sub_administrator || [],
              ordinary: data.ordinary || [],
              groupMemberSessionId: selectedSession.sessionId
            });
          }
          const permissionEnum = rawSetting?.permissionEnum;
          const privateTo = session.settings?.privateTo;
          if (privateTo && permissionEnum === 0) {
            session.settings = {
              ...rawSetting,
              ...newSetting,
              privateTo
            };
          } else {
            session.settings = {
              ...rawSetting,
              ...newSetting,
              privateTo: null
            };
          }
        }
        yield executePut(put, "updateSelectedSession", {
          selectedSession: { ...selectedSession, ...session }
        });
      }
      // console.log("getAllSessionList===upsertSession", session.info.name, session);

      // Bus.emit(`chat:session-update:${session.sessionId}`, session);
      const index = getSessionIndex(allSessionList, session);
      if (index >= 0) {
        // 低效
        const oldTimer = allSessionList[index].timestamp;
        const newTimer = session.timestamp;
        allSessionList[index] = {
          ...allSessionList[index],
          ...session,
          timestamp: Math.max(oldTimer, newTimer)
        };

        // todo 暂时处理，不清楚之前的逻辑考虑
        if (session.lastMsg === undefined) {
          allSessionList[index].lastMsg = undefined;
        }
        // allSessionList.splice(index, 1, { ...allSessionList[index], ...session });
        sortSessions(allSessionList);
        sendGroupSessionNotify(allSessionList);
      } else {
        allSessionList.push(session);
      }
      if (
        session.isNotice &&
        (isCustomAppSession(session, customAppList) || typeof isCustomApp === "boolean")
      ) {
        if (isCustomApp) {
          if (!customAppList.find((item: any) => item.appKey === session.info.userId)) {
            customAppList.push(session);
            const tabIndex = filterTabList.findIndex(
              (item: any) => item.pin === session.info.userId
            );
            if (tabIndex > -1) {
              filterTabList.splice(tabIndex, 1);
              if (!filterTabList.find((item: any) => item.pin === selectedAITab.pin)) {
                yield executePut(put, "updateSelectedAITab", {
                  selectedAITab: {
                    pin: "all-notice",
                    name: "全部"
                  }
                });
              }
              yield executePut(put, "updateFilterTabList", {
                filterTabList: [...filterTabList]
              });
            }
          }
        } else {
          const index = customAppList.findIndex(
            (item: Session) => item.sessionId === session.sessionId
          );
          if (index > -1) {
            customAppList.splice(index, 1, session);
          }
        }
        const aiNoticeSessionList = allSessionList.filter(
          (session: Session) => session.isNotice && isAINoticeChildSession(session, customAppList)
        );
        yield executePut(put, "updateAISessionList", {
          aiNoticeSessionList
        });
        yield executePut(put, "updateCustomAppList", {
          customAppList: [...customAppList]
        });
        if (isAINoticeSession(session)) {
          allSessionList.find((item: Session) =>
            isAINoticeSession(item)
          ).timestamp = computeAITimestamp(aiNoticeSessionList);
          // session.timestamp =

          sortSessions(allSessionList);
        }
      }
      if (!isSessionLoad) {
        return;
      }
      yield executePut(put, "updateSessionList", { allSessionList });
      // 触发更新未读数量功能；
      yield executePut(put, "updateCount", {});
      if (isMeetingSessionId(session.sessionId)) {
        if (session.settings?.privateTo) {
          yield executePut(put, "setPrivateUser", session.settings?.privateTo);
        }
      }
      // 发送通知（未读个数）消息
    },

    *upsertSessionBatch({ payload }: any, { put, select, call }: any) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      if (!chatState.loadAllSessionListEnd) {
        return;
      }
      let { sessions } = payload;
      let allSessionList = chatState.allSessionList || [];
      sessions = sessions.length ? sessions : allSessionList;
      let aiNoticeSessionList = chatState.aiNoticeSessionList || [];
      let selectedSessionId = chatState.selectedSession?.sessionId;
      let selectedSession = chatState.selectedSession;
      const skipAnchorId = chatState.allSessionList || {};
      const customAppList = chatState.customAppList || [];
      const filterTabList = chatState.filterTabList || [];
      const selectedAITab = chatState.selectedAITab || {};
      const cloneSessions = cloneDeep(sessions);
      for (let session of cloneSessions) {
        // 过滤不需要的会话更新
        if (isUnnecessarySession(session)) {
          continue;
        }
        const isAIChat = yield isAIChatSessionId(session.sessionId);
        if (isAIChat) {
          continue;
        }
        if (session && !session.timestamp) {
          session.timestamp = Date.now();
        }
        // 更新session时。如果没有时间戳 或者名称 或者头像的
        if (isInValidSessionInfo(session)) {
          const imService = ImService.getInstance();
          session = yield call(imService.reloadSession.bind(imService), session);
          if (isInValidSessionInfo(session)) {
            continue;
          }
        }
        session = lodashPick(session, sessionAttrs);
        // 更新会话
        if (selectedSessionId === session.sessionId) {
          // session.info = selectedSession.info;
          if (session.unreadCount && !skipAnchorId?.skipId) {
            session.lastReadMidFork = session.lastReadMid;
            session.unreadCountFork = session.unreadCount;
          }
          yield executePut(put, "updateSelectedSession", {
            selectedSession: {
              ...chatState.selectedSession,
              ...session
            }
          });
        }
        const index = getSessionIndex(allSessionList, session);
        if (index >= 0) {
          // 低效
          const oldTimer = allSessionList[index].timestamp;
          const newTimer = session.timestamp;
          // session.info = allSessionList[index].info;
          allSessionList[index] = {
            ...allSessionList[index],
            ...session,
            timestamp: Math.max(oldTimer, newTimer)
          };
          // todo 暂时处理，不清楚之前的逻辑考虑
          if (session.lastMsg === undefined) {
            allSessionList[index].lastMsg = undefined;
          }
          sendGroupSessionNotify(allSessionList);
        } else {
          allSessionList.push(session);
        }
        if (session.isNotice && isCustomAppSession(session, customAppList)) {
          const tabIndex = filterTabList.findIndex((item: any) => item.pin === session.info.userId);
          if (tabIndex > -1) {
            filterTabList.splice(tabIndex, 1);
            if (!filterTabList.find((item: any) => item.pin === selectedAITab.pin)) {
              yield executePut(put, "updateSelectedAITab", {
                selectedAITab: {
                  pin: "all-notice",
                  name: "全部"
                }
              });
            }
            yield executePut(put, "updateFilterTabList", {
              filterTabList: [...filterTabList]
            });
          }
          const aiSessionIndex = getSessionIndex(aiNoticeSessionList, session);
          if (aiSessionIndex > -1) {
            aiNoticeSessionList.splice(aiSessionIndex, 1);
          }
        }
        if (session.isNotice && isAINoticeChildSession(session, customAppList)) {
          const aiSessionIndex = getSessionIndex(aiNoticeSessionList, session);
          if (aiSessionIndex > -1) {
            aiNoticeSessionList[aiSessionIndex] = {
              ...aiNoticeSessionList[aiSessionIndex],
              ...session
            };
          } else {
            aiNoticeSessionList.unshift(session);
          }
          const aiSession = allSessionList.find((item: Session) => isAINoticeSession(item)) || {};
          aiSession.timestamp = computeAITimestamp(aiNoticeSessionList);
        }
      }
      sortSessions(allSessionList);
      yield executePut(put, "updateAISessionList", {
        aiNoticeSessionList
      });
      if (!isSessionLoad) {
        return;
      }
      yield executePut(put, "updateSessionList", { allSessionList });
      yield executePut(put, "updateCount", {});
    },

    *updateSessionEvent({ payload }: any, { put, select }: any) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      if (!chatState.loadAllSessionListEnd) {
        return;
      }
      let { session } = payload;
      const selectedSession = chatState.selectedSession || {};
      const selectedSessionId = selectedSession.sessionId;
      const allSessionList = chatState.allSessionList || [];
      if (selectedSessionId === session.sessionId) {
        const newSession = { ...selectedSession, ...session };
        yield executePut(put, "updateSelectedSession", {
          selectedSession: newSession
        });
        Bus.emit(`chat:session-update:${session.sessionId}`, newSession);
      }
      const idx = findLastIndex(
        allSessionList,
        (item: any) => item.sessionId === session.sessionId
      );
      if (idx > -1) {
        allSessionList[idx] = { ...allSessionList[idx], ...session };
        yield executePut(put, "updateSessionList", { allSessionList });
      }
    },

    *updateChatUser({ payload }: any, { put, select }: any) {
      const { user } = payload;
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const allSessionList = chatState.allSessionList || [];
      const sessionMessageMap = chatState.sessionMessageMap || {};
      const selectedSession = chatState.selectedSession;

      const selectedSessionId = selectedSession.sessionId;
      // const idx = findLastIndex(allSessionList, (item: any) => {
      //     const info = item.info as Employee;
      //     if (info && isEqualEmployee(info, user)) {
      //         return true;
      //     }
      // });
      // if (idx > -1) {
      //     allSessionList[idx].info = user;
      //     const item = allSessionList[idx];
      //     if (selectedSessionId === item.sessionId) {
      //         selectedSession.info = user;
      //         yield executePut(put, 'updateSelectedSession', { selectedSession });
      //     }
      //     if (sessionMessageMap[item.sessionId]?.length) {
      //         sessionMessageMap[item.sessionId] = sessionMessageMap[item.sessionId].map(
      //             (msg: any) => {
      //                 const sender = msg.sender as Employee;
      //                 if (sender && isEqualEmployee(sender, user)) {
      //                     msg.sender = user;
      //                 }
      //                 return msg;
      //             }
      //         );
      //     }
      //     yield executePut(put, 'updateSessionList', { allSessionList });
      // }
      let newSelectedSession = null;
      const newAllSessionList = allSessionList.map((item: any) => {
        let newItem = item;
        if (item.info && isEqualEmployee(item.info, user)) {
          if (selectedSession.sessionId === item.sessionId) {
            newSelectedSession = { ...selectedSession, info: user };
          }
          newItem = {
            ...newItem,
            info: user
          };
        }
        return newItem;
      });
      yield executePut(put, "updateSessionList", { allSessionList: newAllSessionList });
      if (newSelectedSession) {
        yield executePut(put, "updateSelectedSession", {
          selectedSession: newSelectedSession
        });
      }
      // if (selectedSession?.isGroup) {
      if (sessionMessageMap[selectedSessionId]?.length) {
        sessionMessageMap[selectedSessionId] = sessionMessageMap[selectedSessionId].map(
          (msg: any) => {
            const sender = msg.sender as Employee;
            if (sender && isEqualEmployee(sender, user)) {
              msg.sender = user;
            }
            return msg;
          }
        );
      }
      // }
      yield executePut(put, "updateSessionMessage", { sessionMessageMap });
    },

    *addSession({ payload }: any, { put, select }: any) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      //    新群解散之后无法显示在会话列表中
      // if (!chatState.loadAllSessionListEnd) {
      //     return;
      // }
      let { session } = payload;
      if (session && !session.timestamp) {
        session.timestamp = Date.now();
      }
      let { allSessionList = [] } = chatState;
      // 更新session时。如果没有时间戳 或者名称 或者头像的
      if (isInValidSessionInfo(session)) {
        const imService = ImService.getInstance();
        session = yield imService.reloadSession(session);
        if (isInValidSessionInfo(session)) {
          return;
        }
      }
      session = lodashPick(session, sessionAttrs);
      // allSessionList = allSessionList || [];
      if (allSessionList.length === 0) {
        allSessionList.unshift(session);
      } else {
        // 进行重新排序
        session.timestamp = Date.now();
        allSessionList = addOneSession(allSessionList, session);
      }
      if (session.isGroup) {
        sendGroupSessionNotify(allSessionList);
      }
      yield executePut(put, "updateSessionList", { allSessionList });
      // 触发更新未读数量功能；
      yield executePut(put, "updateCount", {});
    },

    *updateIMConnectState({ payload }: any, { put, select }: any) {
      let { connectState } = payload;
      // 状态冲突时检测
      if (
        !isLinuxOs() &&
        ((!navigator.onLine && connectState?.state !== ConnectState.OFFLINE) ||
          (navigator.onLine && connectState?.state === ConnectState.OFFLINE))
      ) {
        const netServer = NetworkCheck.getInstance({
          url: getNetCheckUrl(),
          checkType: UseCheckType.API
        });
        const isOnline = yield netServer.checkNet();
        if (
          (isOnline && !navigator.onLine) ||
          (!isOnline && connectState?.state === ConnectState.OFFLINE)
        ) {
          yield executePut(put, "updateConnectState", { connectState });
        }
      } else {
        yield executePut(put, "updateConnectState", { connectState });
      }
    },

    *viewCardReadBatch({ payload }: any, { put, select }: any) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const { selectedSession = {} } = chatState;
      // console.log('进入会话', selectedSession);
      if (isAINoticeSession(selectedSession)) {
        const filterMessgaes = payload.messages.filter(
          (message: any) =>
            isNoticeMessage(message) &&
            !isSysMessage(message) &&
            message?.extend.bizId &&
            message?.extend.readRecord === true
        );
        // console.log('过滤', filterMessgaes);
        if (filterMessgaes?.length > 0) {
          addBatchViewCardRead(filterMessgaes).then();
        }
      }
    },

    *updateExternalContacts({ payload }: any, { put, select }: any) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const { selectedSession = {}, allSessionList } = chatState;
      const { user } = payload;
      const { remark, userId, teamId, appId } = user;
      const userKey = `${userId}:${appId}:${teamId}`;
      const replaceRemark = (session: any) => {
        const {
          info: { rosters = {} }
        } = session;
        if (rosters[userKey]) {
          rosters[userKey].info.employeeExt.remark = remark;
        }
        if (session.info.userId === userId && session.info?.employeeExt) {
          session.info.employeeExt.remark = remark;
        }
        const sender = session.lastMsg?.sender;
        if (sender?.userId === userId && sender.employeeExt) {
          sender.employeeExt.remark = remark;
        }
      };
      allSessionList.forEach((session: any) => {
        replaceRemark(session);
      });
      yield executePut(put, "updateSessionList", { allSessionList });
      if (selectedSession.sessionId) {
        replaceRemark(selectedSession);
        yield executePut(put, "updateSelectedSession", {
          selectedSession: selectedSession
        });
      }
    },
    *getCustomNoticeSession({ payload }: any, { put, select }: any) {
      const { isEmit = false } = payload || {};
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const imService = ImService.getInstance();
      const appRes = yield queryAllCustomAppConfig();
      if (!appRes) {
        return;
      }
      const currentEmployee = chatState.currentEmployee;
      const { globalConfigList, userConfigList } = appRes;
      if (userConfigList || globalConfigList) {
        const userSessionIds =
          userConfigList?.map((item: any) => {
            return imService.generateSingleSessionId(
              {
                app: "dd.notice",
                userId: item.appKey,
                teamId: "focus.bot"
              } as any,
              {
                pin: (currentEmployee as Employee).userId,
                app: (currentEmployee as Employee).app,
                teamId: (currentEmployee as Employee).teamId
              }
            );
          }) || [];
        const globalSessionIds =
          globalConfigList?.map((item: any) => {
            return imService.generateSingleSessionId(
              {
                app: "dd.notice",
                userId: item.appKey,
                teamId: "focus.bot"
              } as any,
              {
                pin: (currentEmployee as Employee).userId,
                app: (currentEmployee as Employee).app,
                teamId: (currentEmployee as Employee).teamId
              }
            );
          }) || [];
        const sessionIds = [...globalSessionIds, ...userSessionIds];
        const sessions = (yield imService.getSessionsByIds(sessionIds)) || [];
        const miss = difference(
          sessionIds,
          sessions.map((s: any) => s.sessionId)
        );
        let rest = yield Promise.all(
          miss.map((s) => imService.getSessionBySessionId({ sessionId: s }))
        );
        rest = rest
          .filter((i: any) => !!i)
          .map((s: any) => {
            if (globalSessionIds.includes(s.sessionId)) {
              return {
                ...s,
                settings: {
                  ...s.settings,
                  isShow: false
                }
              };
            } else {
              return s;
            }
          });
        const allList = [...sessions, ...rest];
        if (isEmit) {
          Bus.emit(
            "chat:session-update-batch",
            allList.filter((s) => s?.settings?.isShow !== false)
          );
        }
        yield executePut(put, "updateCustomAppList", {
          customAppList: allList
        });
      }
    },
    *getLLMAgentList({ payload }: any, { put, select }: any) {
       try {
        const { agents } = yield getAgentList();
        console.log(`tj:>>getLLMAgentList>`, agents);
        if (agents?.length) {
          yield executePut(put, "updateLLMAgent", agents);
          const defaultSelect =
            agents.findLast((i: any) => i.selected === true) || agents.slice(-1)[0];
          // 默认选择
          if (defaultSelect) {
            yield executePut(put, "setCurrentAIRobot", defaultSelect);
          }
          yield executePut(put, "getLLMTagsList", { agentId: defaultSelect?.agentId });
        }
      } catch (e) {
        console.log("getLLMAgentList error", e);
      }
    },
    *getLLMTagsList({ payload }: any, { put, select }: any) {
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const llmTagsList = chatState.llmTagsList;
      console.log(`tj:>>>getLLMTagsList1112222>>`, llmTagsList);
      const force = payload?.force;
      console.log(`tj:>>>getLLMTagsList333>>`, force);
      const hasData = llmTagsList?.content_tags?.length || llmTagsList?.question_tags?.length;
      if (hasData && !force) {
        return;
      }
      try {
        const res = yield getFeedbackTags();
        const { content_tags = [], question_tags = [] } = res || {};
        yield executePut(put, "updateLLMTagsList", {
          content_tags,
          question_tags
        });
      } catch (e) {
        console.log("getLLMTagsList error");
      }
      try {
        const opts = payload || {};
        const allSetting = yield getAllLLMSetting(opts);
        if (allSetting) {
          if (payload?.agentId === "DR.JOY") {
            allSetting.recIcon = agentReqIcon;
          }
          yield executePut(put, "updateLLMSetting", allSetting);
          // 设置sdk配置
          yield ImService.getInstance().setLLMSetting(allSetting);
        }
      } catch (e) {
        console.log("getLLMTagsList error");
      }
    },
    *loadGroupRobots({ payload }: any, { put, select }: any) {
      console.log("loadGroupRobots~~~:", payload);
      const chatState = yield select(({ chat }: { chat: ChatState }) => chat);
      const { session = {} } = payload;
      const { selectedSession = {}, allSessionList } = chatState;
      if (selectedSession.sessionId === session.sessionId && session.isGroup) {
        try {
          // 初始化加载组机器人
          const groupBotsRes = yield groupGetBotList({
            groupId: selectedSession.sessionId || selectedSession.gid || ""
          }).catch((err: any) => {
            console.error("groupGetBotList-err", err);
            return { items: [] };
          });
          const botItems = groupBotsRes.items.map((item: any) => {
            return { userId: item.botId, appId: item.app, teamId: item.teamId };
          });
          const botList = yield ImService.getInstance().getChangeUserDetailList(botItems);
          yield executePut(put, "setGroupRobots", {
            groupRobots:
              botList.map((item: any, index: any) => {
                return { ...item, botId: item.userId, role: "robot" };
              }) || []
          });
        } catch (err) {
          console.log("loadGroupRobots error");
        }
      }
    }
  },

  subscriptions: {
    "session-event"({ dispatch }: any, onError: (reason?: any) => void) {
      Bus.on("chat:session-update", (session) => {
        console.log("getAllSessionList===chat:session-update", session);

        dispatch({ type: "upsertSession", payload: { session, type: "update" } });
      });
      Bus.on("chat:session-update-batch", (sessions) => {
        console.log("getAllSessionList===session-update-batch", sessions);

        dispatch({ type: "upsertSessionBatch", payload: { sessions, type: "update" } });
      });
      Bus.on("chat:session-add", (session) => {
        // logger.debug('chat:session-add', session);
        dispatch({ type: "addSession", payload: { session } });
      });
      Bus.on("chat:session-del", (session) => {
        console.log("getAllSessionList===chat:session-del", session);

        Bus.emit(`chat:session-remove:${session.sessionId}`, session.sessionId); // 触发session和topUpsession中的监听事件，纵向置顶要移除，横向置顶不操作
        dispatch({
          type: "removeSession",
          payload: { sessionId: session.sessionId, force: session.force }
        });
        dispatch({ type: "updateCount", payload: {} });
      });
      Bus.on("chat:session-list", (sessionList) => {
        // 更新sessionList
        dispatch({ type: "updateSessionList", payload: { allSessionList: sessionList } });
      });
      Bus.on("chat:state", (state) => {
        Bus.emit("chat:connect_state_change", { connectState: state });
        console.log("model触发---", state);
        dispatch({ type: "updateIMConnectState", payload: { connectState: state } });
      });
      Bus.on("chat:top-search-group-session", (data) => {
        dispatch({ type: "launchGroupSession", payload: { sid: data.id } });
      });
      Bus.on("chat:top-search-single-session", (data) => {
        dispatch({ type: "launchSingleSession", payload: { user: data } });
      });
      Bus.on("employee:user-update", (user) => {
        dispatch({ type: "updateChatUser", payload: { user } });
      });
      Bus.on("chat:message-destroy", (messages) => {
        dispatch({ type: "destroySessionMessage", payload: { messages } });
      });
      Bus.on("chat:message-delete", (message) => {
        dispatch({ type: "deleteSessionMessage", payload: { message } });
      });
      Bus.on("chat:message-clear", (sessionId) => {
        dispatch({ type: "clearSessionMessage", payload: { sessionId } });
      });
      Bus.on("chat:card-read-batch", (messages) => {
        // console.log('模糊已读', messages);
        dispatch({ type: "viewCardReadBatch", payload: { messages } });
      });
      Bus.on("ebook:updateExternalContacts", (user) => {
        dispatch({ type: "updateExternalContacts", payload: { user } });
      });
      Bus.on("chat:load-group-robots", (session) => {
        console.log("model load-group-robots:", session);
        dispatch({ type: "loadGroupRobots", payload: { session } });
      });
    }
  }
};
